/* eslint-disable react/prop-types */

import React, { useEffect, useRef, useState } from 'react';

import Grid from '@mui/material/Grid';

import Typography from '@mui/material/Typography';

import TextField from '@mui/material/TextField';

import Button from '@mui/material/Button';

import FormControl from '@mui/material/FormControl';

import useMediaQuery from '@mui/material/useMediaQuery';

import { useTheme } from '@mui/material/styles';

import './EditPatient.css';

import dayjs from 'dayjs';
import HistoryIcon from '@mui/icons-material/History';

import { DatePicker, DesktopDatePicker } from '@mui/x-date-pickers';

import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import {
	Alert,
	Autocomplete,
	Badge,
	Box,
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Modal,
	Select,
	Snackbar,
	Tooltip,
	Drawer,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { states } from '../../../services/Settings';

import { settings as s } from '../../../services/Settings';

import CallIcon from '@mui/icons-material/Call';

import DownloadIcon from '@mui/icons-material/Download';

import { saveAs } from 'file-saver';

import { CircularProgress } from '@mui/material';

import MaskedInput from 'react-text-mask';

import {
	getPatientListById,
	putPatientDetail,
	getPatAdmId,
	putPatAdmData,
	getVisitDataByID,
	getPatInsById,
	getLocation,
	GetAttahcmentFile,
	savefilepost,
	PutAttahcmentFile,
	PostAttahcmentFile,
	postPatNotes,
	moveToMaximusExport,
} from '../../../services/api/apiManager';

import {
	postAddPatAdmData,
	getPayers,
	postAddPatientInsuranceData,
	putPatientInsData1,
	getPatientNotes,
} from '../../../services/api/apiManager';

import { useNavigate } from 'react-router-dom';

import { useLocation } from 'react-router';

import { useStateValue } from '../../../services/state/State';

import * as Yup from 'yup';

import CancelIcon from '@mui/icons-material/Cancel';

import AddIcon from '@mui/icons-material/Add';

import AddTaskIcon from '@mui/icons-material/AddTask';

import { DataGrid } from '@mui/x-data-grid';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';

function EditPatient() {
	const theme = useTheme();
	const [open, setOpen] = React.useState(false);
	const [notes, setNotes] = useState([]);
	const [dataForDelete, setDataForDelete] = React.useState('');
	const [{ providers }] = useStateValue(); // Dispatch State Value
	const darkNavigate = useNavigate(); // Page Navigate variable
	const practice_id = localStorage.getItem('practice_id'); // Get Practice Id from Local Storage
	const username = localStorage.getItem('userName'); // Get Practice Id from Local Storage
	const location = useLocation();
	const [showNotes, setShowNotes] = useState(false);
	const [editSave, setEditSave] = useState(false); // for Disabled Edit Save Button
	const pastVisitId = location?.state?.id3; // Get past Visit ID
	const [patvisitlist, setPatvisitlist] = useState([]); // Get Patient Visit Data State
	const [openSnackbar, setOpenSnackbar] = useState(false); // Snackbar For Success State
	const [openValidateSnackbar, setOpenValidateSnackbar] = useState(false); // Snackbar Open State if textfield empty
	const [openEmptySnackbar, setOpenEmptySnackbar] = useState(false); // Snackbar for Empty Fields State
	const [insListName, setInsListName] = useState([]); // Get Insurance Data Drop Down State
	const [idOfInsData, setIdOfInsData] = useState(); // Get Id of Patient Inusrance using update method state
	const [insIds, setInsIds] = useState([]); // Get Ids of Patient Inusrance using update method state
	const [allInsIds, setAllInsIds] = useState([]); // Get All Ids of Patient Inusrance using update method state
	const [locationGet, setLocationGet] = React.useState([]); // Get Location Drop Down State
	const [errors, setErrors] = useState({}); //  Error Validation State
	const [firstLoading, setFirstLoading] = useState(false); // Loading State
	const [secondLoading, setSecondLoading] = useState(false); // Loading State
	const [downloadingFileId, setDownloadingFileId] = useState(null);
	const [loading, setLoading] = useState(false); // Loading State
	const maxDate = new Date();
	maxDate.setMonth(maxDate.getMonth() + 1);
	const fileInputRef = useRef(null);
	const [dataFetched, setDataFetched] = useState(false);
	const [selectedFiles, setSelectedFiles] = useState([]);
	// Filter to get only File instances
	const fileObjects = selectedFiles.filter((item) => item instanceof File);
	const setFileNames = fileObjects?.map((file) => file?.name);
	const [showErr, setShowErr] = useState(false);

	// For Adding Notes
	const [resPatData, setResPatData] = useState([]);
	const [resPatAdm, setResPatAdm] = useState([]);
	const [resPatInsurance, setResPatInsurance] = useState([]);
	const [updatePatData, setUpdatePatData] = useState([]);
	const [postPatAdm, setPostPatAdm] = useState([]);
	const [putPatAdm, setPutPatAdm] = useState([]);
	const [postResInsuranceData, setPostResInsuranceData] = useState([]);
	const [putResInsuranceData, setPutResInsuranceData] = useState([]);
	const [initialAttachments, setInitialAttachments] = useState([]);
	const [addedAttachments, setAddedAttachments] = useState([]);
	const [deletedAttachments, setDeletedAttachments] = useState([]);
	const [insErrors, setInsErrors] = useState([]);
	const [insuranceForms, setInsuranceForms] = useState([]);
	const [allInsuranceData, setAllInsuranceData] = useState([]);

	const [openPastVisitInfo, setOpenPastVisitInfo] = React.useState(false);
	const handleOpenPastVisitInfo = () => setOpenPastVisitInfo(true);
	const handleClosePastVisitInfo = () => setOpenPastVisitInfo(false);
	// Pagination States here
	const [changePage, setChangePage] = useState({
		in_Page_Number: 0,
		in_Rows: 100,
	});
	const [paginationModel, setPaginationModel] = React.useState({
		page: 0,
		pageSize: 5,
	});

	// Data Grid Table Info...

	const InsuranceColumn = [
		{
			field: 'id',
			headerName: 'Sr.No',
			flex: 0.8,
			minWidth: 20,
		},
		{
			field: 'planName',
			headerName: 'Plan',
			flex: 1,
			minWidth: 70,
		},
		{
			field: 'insuranceName',
			headerName: 'Insurance',
			flex: 1,
			minWidth: 120,
			valueGetter: (params) => {
				const id = params?.row?.insuranceName;
				const match = insListName?.find((x) => x.id === id);
				return match ? match.Name : '';
			},
		},
		{
			field: 'groupName',
			headerName: 'Group',
			flex: 1,
			minWidth: 50,
		},
		{
			field: 'policyNo',
			headerName: 'Policy',
			flex: 0.5,
			minWidth: 50,
		},
		{
			field: 'actions',
			headerName: 'Actions',
			sortable: false,
			filterable: false,
			flex: 0.5,
			minWidth: 90,
			renderCell: (params) => {
				const currentId = allInsIds[params?.id - 1];
				return (
					<Box sx={{ display: 'flex', gap: 1 }}>
						<Tooltip title="Edit" placement="left">
							<IconButton
								color="primary"
								onClick={() => {
									handleAddInsuranceForm(params?.row);
									setCurrentInsId(currentId);
								}}
								size="small"
								sx={{ color: '#0D406F' }}
							>
								<BorderColorIcon fontSize="small" />
							</IconButton>
						</Tooltip>
						<Tooltip title="Delete" placement="top-end">
							<IconButton
								color="error"
								onClick={() => {
									SetOpenInsPopup(true);
									setInsPlan(params?.row);
									setCurrentInsId(currentId);
								}}
								size="small"
								sx={{ color: '#ED2828' }}
							>
								<DeleteIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Box>
				);
			},
		},
	];

	const handleAddInsuranceForm = (data) => {
		setInsuranceForms((prev) => {
			// If EDIT (data exists)
			if (data) {
				// replace the single form with edit data
				return [
					{
						planName: data.planName || '',
						insuranceName: data.insuranceName || '',
						policyNo: data.policyNo || '',
						groupName: data.groupName || '',
						// id: data.id,
						action: 'put',
					},
				];
			}

			// If ADD (no data)
			return [
				...prev,
				{
					planName: '',
					insuranceName: '',
					policyNo: '',
					groupName: '',
					action: 'post',
				},
			];
		});
	};

	const handleCloseInsuranceForm = (indexNo) => {
		const removerForm = insuranceForms?.filter((items, index) => {
			return index != indexNo;
		});
		setInsuranceForms(removerForm);

		setInsErrors((prevErrors) => {
			const updatedErrors = [...prevErrors];
			updatedErrors.splice(indexNo, 1);
			return updatedErrors;
		});
	};
	const handleFileSelect = (event) => {
		const files = Array.from(event.target.files);
		const setEventData = files?.map((file) => file?.name);
		const setAttachmentData = selectedFiles?.map(
			(file) => file?.AttachmentName
		);
		const hasMatchingNames = setEventData.some((fileName) =>
			setAttachmentData.includes(fileName)
		);
		const hasMatchingSelectFileName = setEventData.some((fileName) =>
			setFileNames.includes(fileName)
		);
		if (hasMatchingNames || hasMatchingSelectFileName) {
			setShowErr(true);
			setTimeout(() => {
				setShowErr(false);
			}, 2000);
		} else {
			setSelectedFiles((prev) => [...prev, ...files]);
		}
	};
	const toggleNotes = () => {
		setShowNotes((prev) => !prev);
	};
	const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
	const [deletePopupOpen, setDeletePopupOpen] = React.useState(false);
	const handleClose = () => {
		setOpen(false);
	};
	const deleteCancelPopup = () => {
		setDeletePopupOpen(false);
	};
	const [insPlan, setInsPlan] = React.useState({});
	const [currentInsId, setCurrentInsId] = React.useState(null);
	// Insurance Dialogue States here
	const [openInsPopup, SetOpenInsPopup] = React.useState(false);
	const deleteInsPopup = () => {
		SetOpenInsPopup(false);
	};

	const deleteFileGetId = (e) => {
		setDataForDelete(e);
		setDeletePopupOpen(true);
	};

	const handleFileRemove = (fileToRemove) => {
		setSelectedFiles((prevFiles) =>
			prevFiles.filter((file) => file !== fileToRemove)
		);
		if (fileInputRef.current) {
			fileInputRef.current.value = [];
		}
	};

	// All Patient Text Fields states here
	const [patientStates, setPatientStates] = useState({
		fname: '',
		lname: '',
		dob: null,
		mrn: '',
		adm: null,
		dischargeDate: null,
		room: '',
		bedNo: '',
		gender: '',
		provider: '',
		refphy: '',
		location: '',
		contact: '',
		cnotes: '',
		pname: '',
		iname: '',
		policy: '',
		gname: '',
		address: '',
		cc: '',
		ccr: '',
		con: '',
		city: '',
		state: '',
		zip: '',
	});

	const isFilled = (value) => {
		if (value == null) return false;
		const digitCount = (value.match(/\d/g) || [])?.length;
		return digitCount === 10;
	};

	const handleChangePatientStates = (e) => {
		// const { name, value } = e.target;
		// setPatientStates((prev) => {
		// 	return { ...prev, [name]: value };
		// });
		if (e?.target) {
			const { name, value } = e.target;
			setPatientStates((prev) => ({
				...prev,
				[name]: value,
			}));
		} else {
			setPatientStates((prev) => ({
				...prev,
				state: e,
			}));
		}
	};

	const handleDateOfBirthChange = (date) => {
		setPatientStates((prev) => {
			return { ...prev, dob: date };
		});
	};

	const handleAdmissionDateChange = (date) => {
		setPatientStates((prev) => {
			return { ...prev, adm: date };
		});
	};

	const handleDischargeDateChange = (date) => {
		setPatientStates((prev) => {
			return { ...prev, dischargeDate: date };
		});
	};
	const schema = Yup.object().shape({
		// Section of Alphabets only
		fname: Yup.string().test(
			'alphabets-only',
			'Alphabets only, no extra spaces allowed',
			(value) => {
				return !value || /^[a-zA-Z]+( [a-zA-Z]+)*$/.test(value.trim());
			}
		),
		lname: Yup.string().test(
			'alphabets-only',
			'Alphabets only, no extra spaces allowed',
			(value) => {
				return !value || /^[a-zA-Z]+( [a-zA-Z]+)*$/.test(value.trim());
			}
		),
		// cnotes: Yup.string().test('no-numbers', 'No numbers allowed', (value) => {
		// 	return !value || /^[^\d]+$/.test(value);
		// }),

		pname: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		gname: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		// address: Yup.string().test(
		// 	'alphabets-numbers-only',
		// 	'Alphabets & numbers only',
		// 	(value) => {
		// 		return !value || /^[a-zA-Z0-9,\s]+$/.test(value);
		// 	}
		// ),
		cc: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		ccr: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		city: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		state: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		// Section of Numbers only
		room: Yup.string().test(
			'alphabets-numbers-only',
			'Alphabets & numbers only',
			(value) => {
				return !value || /^[a-zA-Z0-9,\s]+$/.test(value);
			}
		),
		bedNo: Yup.string().test(
			'alphabets-numbers-only',
			'Alphabets & numbers only',
			(value) => {
				return !value || /^[a-zA-Z0-9,\s]+$/.test(value);
			}
		),
		policy: Yup.string().test(
			'alphanumeric-only',
			'Alphanumeric characters only',
			(value) => {
				return !value || /^[a-zA-Z0-9]+$/.test(value);
			}
		),
		zip: Yup.string().test('numbers-only', 'Numbers only', (value) => {
			return !value || /^\d+$/.test(value);
		}),
		mrn: Yup.string()
			.max(10, 'MRN must not exceed 10 characters')
			.test(
				'alphabets-numbers-only',
				'Only alphabets and numbers are allowed',
				(value) => !value || /^[a-zA-Z0-9]+$/.test(value)
			),

		// Section of Contact Number only
		contact: Yup.string().test('contact-format', 'Invalid', (value) => {
			return (
				!value ||
				/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value)
			);
		}),
		con: Yup.string().test('contact-format', 'Invalid', (value) => {
			return (
				!value ||
				/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value)
			);
		}),
		// dob: Yup.date().required('Date of birth is required'),
		// adm: Yup.date().required('Admission date is required'),
		// dischargeDate: Yup.date().required('Discharge Date is required'),
	});

	const singleInsuranceSchema = Yup.object().shape({
		planName: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),

		groupName: Yup.string().test(
			'alphabets-only',
			'Alphabets only',
			(value) => {
				return !value || /^[a-zA-Z\s]+$/.test(value);
			}
		),

		policyNo: Yup.string().test(
			'alphanumeric-only',
			'Alphanumeric characters only',
			(value) => {
				return !value || /^[a-zA-Z0-9]+$/.test(value);
			}
		),
	});
	// set Date of Birth
	const year = new Date(patientStates?.dob).getFullYear();
	const month = (new Date(patientStates?.dob).getMonth() + 1)
		.toString()
		.padStart(2, '0');
	const day = new Date(patientStates?.dob)
		.getDate()
		.toString()
		.padStart(2, '0');
	const formattedDate = year ? `${year}-${month}-${day}` : null;

	// set Admission date format

	const year1 = new Date(patientStates?.adm).getFullYear();
	const month1 = (new Date(patientStates?.adm).getMonth() + 1)
		.toString()
		.padStart(2, '0');
	const day1 = new Date(patientStates?.adm)
		.getDate()
		.toString()
		.padStart(2, '0');
	const formattedDate1 = year1 ? `${year1}-${month1}-${day1}` : null;

	// Convert Discharge Date into string format
	const year3 = new Date(patientStates?.dischargeDate).getFullYear();
	const month3 = (new Date(patientStates?.dischargeDate).getMonth() + 1)
		.toString()
		.padStart(2, '0');
	const day3 = new Date(patientStates?.dischargeDate)
		.getDate()
		.toString()
		.padStart(2, '0');
	const dischargeDate = year3 ? `${year3}-${month3}-${day3}` : null;

	// variables to store api data for update functionality

	const updateData = {
		practice_id: practice_id,
		Fname: patientStates?.fname,
		Lname: patientStates?.lname,
		...(patientStates?.dob !== undefined && {
			DOB: patientStates?.dob ? formattedDate : null,
		}),
		// DOB: patientStates?.dob != null ? formattedDate : undefined,
		Gender: patientStates?.gender,
		Contact: patientStates?.contact,
		Address: patientStates?.address,
		City: patientStates?.city,
		State: patientStates?.state,
		Zip: patientStates?.zip,
		MRN: patientStates?.mrn,
		ClinicalNotes: patientStates?.cnotes,
		CareCoordinator: patientStates?.cc,
		CCContact: patientStates?.con,
		CCRelation: patientStates?.ccr,
		Inactive:
			patientStates?.dischargeDate != null ? true : patientStates?.activeState,
	};

	const updatePatAdmData = {
		practice_id: practice_id,
		refphy_id:
			patientStates?.refphy != null ? patientStates?.refphy : undefined,
		provider_id:
			patientStates?.provider != null ? patientStates?.provider : undefined,
		...(patientStates?.location && {
			location_id: patientStates?.location,
		}),
		// location_id: patientStates?.location,
		...(patientStates?.adm !== undefined && {
			Admission_date: patientStates?.adm ? formattedDate1 : null,
		}),
		// Admission_date: patientStates?.adm != null ? formattedDate1 : undefined,
		...(patientStates?.dischargeDate !== undefined && {
			discharge_date: patientStates?.dischargeDate ? dischargeDate : null,
		}),
		// discharge_date:
		// 	patientStates?.dischargeDate != null ? dischargeDate : undefined,
		Room_No: patientStates?.room,
		Bed_No: patientStates?.bedNo,
	};

	const PatientData = {
		practice_id: practice_id,
		patient_id: location?.state?.id,
		refphy_id:
			patientStates?.refphy != null ? patientStates?.refphy : undefined,
		provider_id:
			patientStates?.provider != null ? patientStates?.provider : undefined,
		location_id: patientStates?.location,
		Admission_date: formattedDate1,
		discharge_date: dischargeDate,
		Room_No: patientStates?.room,
		Bed_No: patientStates?.bedNo,
	};
	const getVisitlistWithID = async () => {
		setFirstLoading(true);
		const resp = await getVisitDataByID(location?.state?.id);
		if (resp?.data) {
			setPatvisitlist(resp?.data);
			setFirstLoading(false);
		}
	};
	// function for getpatient notes
	const getPatientNotesData = async (patient_id, practice_id, visit_id) => {
		try {
			const response = await getPatientNotes(patient_id, practice_id, visit_id);

			if (response.status === 200) {
				setNotes(
					response.data.notes?.filter((note) => {
						return (
							!note?.note_text.toLowerCase().includes('undefined') &&
							note?.notecategory == 'patient'
						);
					})
				);
			} else {
				console.log('Unexpected status code:', response.status);
			}
		} catch (error) {
			console.error('Error fetching patient notes:', error);
		}
	};

	// function for getting insurance name

	const showPayerName = async () => {
		const resp = await getPayers();
		setInsListName(resp?.data);
	};

	// fucntion for getting patient insurance data By Id

	const getInsData = async () => {
		const resp = await getPatInsById(location?.state?.id);
		if (resp?.status === 200) {
			setResPatInsurance(resp);
			setIdOfInsData(resp?.data?.patient_insurances[0]?.id);
			setInsIds(resp?.data?.patient_insurances?.slice(1)?.map((i) => i?.id));
			setAllInsIds(resp?.data?.patient_insurances?.map((i) => i?.id));
			setPatientStates((prevState) => ({
				...prevState,
				policy: resp?.data?.patient_insurances[0]?.PolicyNumber,
				gname: resp?.data?.patient_insurances[0]?.GroupName,
				pname: resp?.data?.patient_insurances[0]?.PlanName,
				iname: resp?.data?.patient_insurances[0]?.payer_id,
			}));
			const allInsuranceData = resp?.data?.patient_insurances || [];

			// All insurance forms
			const InsuranceData = allInsuranceData?.map((item, index) => ({
				id: index + 1,
				planName: item?.PlanName || '',
				insuranceName: item?.payer_id || '',
				policyNo: item?.PolicyNumber || '',
				groupName: item?.GroupName || '',
				action: 'put',
			}));
			setAllInsuranceData(InsuranceData);

			// Remaining insurance forms (from index 1 onwards)
			const otherInsuranceData = allInsuranceData?.slice(1)?.map((item) => ({
				planName: item?.PlanName || '',
				insuranceName: item?.payer_id || '',
				policyNo: item?.PolicyNumber || '',
				groupName: item?.GroupName || '',
				action: 'put',
			}));
			// setInsuranceForms(otherInsuranceData);
		}
	};

	// fucntion for getting single patient detail with ID

	const getSinglePatietnDetailWithID = async () => {
		const resp = await getPatientListById(location?.state?.id);
		setResPatData(resp);
		setPatientStates((prevState) => ({
			...prevState,
			fname: resp?.data?.Fname,
			lname: resp?.data?.Lname,
			dob: resp?.data?.DOB,
			contact: resp?.data?.Contact,
			mrn: resp?.data?.MRN,
			gender: resp?.data?.Gender,
			cnotes: resp?.data?.ClinicalNotes,
			address: resp?.data?.Address,
			cc: resp?.data?.CareCoordinator,
			con: resp?.data?.CCContact,
			city: resp?.data?.City,
			state: resp?.data?.State,
			ccr: resp?.data?.CCRelation,
			zip: resp?.data?.Zip,
			activeState: resp?.data?.Inactive,
		}));
	};

	const getLocationData = async () => {
		const resp = await getLocation();
		setLocationGet(resp?.data);
	};
	// function for getting single patient Admission detail with ID
	const getPatAdmSingleDetailWithID = async () => {
		const resp = await getPatAdmId(location?.state?.id2);
		setResPatAdm(resp);
		setPatientStates((prevState) => ({
			...prevState,
			refphy: resp?.data?.refphy_id,
			room: resp?.data?.Room_No,
			provider: resp?.data?.provider_id,
			location: resp?.data?.location_id,
			adm: resp?.data?.Admission_date,
			bedNo: resp?.data?.Bed_No,
			dischargeDate: resp?.data?.discharge_date,
		}));
	};

	const getAttachmentFileData = async () => {
		setLoading(true);
		try {
			const resp = await GetAttahcmentFile(location?.state?.id);
			if (resp && resp?.data) {
				const fetchedFiles = resp.data.filter(
					(item) => item?.visit_id === null
				);
				setInitialAttachments(
					fetchedFiles.map((file) => file?.name || file?.AttachmentName)
				);
				setSelectedFiles(fetchedFiles);
				setDataFetched(true);
			}
		} catch (error) {
			console.error('Error fetching attachment file data:', error);
		} finally {
			setLoading(false);
		}
	};
	const compareAttachments = (initial, updated) => {
		const added = updated.filter((file) => !initial.includes(file));
		const deleted = initial.filter((file) => !updated.includes(file));
		return { added, deleted };
	};
	const deleteFile = {
		Deleted: true,
	};

	const openChooseImg1 = async (imgId, deleteFile) => {
		setDeletePopupOpen(false);
		const resp = await PutAttahcmentFile(imgId, deleteFile);
		if (resp?.request?.status === 200) {
			setLoading(false);
		}
	};

	// snackbar for save button

	const handleClickSnackbar = () => {
		setOpenSnackbar(true);
	};

	//   close Snackbar

	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};

	// Snackbar for Empty Fields

	const ShowEmptySnackbar = () => {
		setOpenEmptySnackbar(true);
	};

	const CancelEmptySnackbar = () => {
		setOpenEmptySnackbar(false);
	};
	const OSW_id = localStorage.getItem('OSW_id');
	const moveToMaximusData = {
		OSW_id: OSW_id,
		visitids: '',
		practice_id: practice_id,
		patient_id: location?.state?.id,
	};
	// For Save Button
	const buttonSubmit = async (
		updateData,
		updatePatAdmData,
		notesLogBodyJson
	) => {
		if (
			patientStates?.fname === '' ||
			patientStates?.lname === ''
			// ||patientStates?.location === undefined ||
			// patientStates?.location === '' ||
			// patientStates?.location === null ||
			// patientStates?.adm === null ||
			// patientStates?.dob === null
		) {
			ShowEmptySnackbar();
			setTimeout(() => {
				setOpenSnackbar(false);
			}, 1500);
		} else if (patientStates?.iname !== '' && patientStates?.policy === '') {
			ShowEmptySnackbar();
			setTimeout(() => {
				setOpenSnackbar(false);
			}, 1500);
		} else if (errors?.fname || errors?.lname || errors.mrn) {
			setOpenValidateSnackbar(true);
			setTimeout(() => {
				setOpenValidateSnackbar(false);
			}, 1500);
		} else {
			setLoading(true);
			setEditSave(true);
			const patAdmId = location?.state?.id2;
			const res = await putPatientDetail(location?.state?.id, updateData);
			if (OSW_id == '1') {
				const resp2 = await moveToMaximusExport(moveToMaximusData);
			}
			setUpdatePatData(res);
			if (!patAdmId) {
				const res = await postAddPatAdmData(PatientData);
				setPostPatAdm(res);
			}
			// if (
			// 	(updatePatAdmData?.discharge_date !== null ||
			// 		updatePatAdmData?.Admission_date !== null ||
			// 		updatePatAdmData?.Room_No !== '' ||
			// 		updatePatAdmData?.Bed_No !== '' ||
			// 		updatePatAdmData?.refphy_id !== undefined ||
			// 		updatePatAdmData?.provider_id !== undefined) &&
			// 	patAdmId
			// ) {
			// 	const res = await putPatAdmData(patAdmId, updatePatAdmData);
			// 	setPutPatAdm(res);
			// }

			if (
				updatePatAdmData?.Admission_date === null &&
				updatePatAdmData?.provider_id === undefined &&
				updatePatAdmData?.refphy_id === undefined
			) {
				if (
					updatePatAdmData?.Room_No === '' &&
					updatePatAdmData?.Bed_No === ''
				) {
					updatePatAdmData.Room_No = '';
					updatePatAdmData.Bed_No = '';
				}
			} else {
				updatePatAdmData.Room_No = updatePatAdmData.Room_No || '';
				updatePatAdmData.Bed_No = updatePatAdmData.Bed_No || '';
			}
			if (patAdmId) {
				const res = await putPatAdmData(patAdmId, updatePatAdmData);
				setPutPatAdm(res);
			}
			if (!idOfInsData) {
				if (patientStates?.iname !== '' && patientStates?.policy !== '') {
					const patientInsuranceData = {
						patient_id: location?.state?.id,
						...(patientStates?.iname && {
							payer_id: patientStates?.iname,
						}),
						...(patientStates?.policy && {
							PolicyNumber: patientStates?.policy,
						}),
						...(patientStates?.gname && {
							GroupName: patientStates?.gname,
						}),
						...(patientStates?.pname && {
							PlanName: patientStates?.pname,
						}),
						Type: 'P',
					};
					if (Object.keys(patientInsuranceData)?.length > 2) {
						const res = await postAddPatientInsuranceData(patientInsuranceData);
						setPostResInsuranceData(res);
					}
				} else {
					if (patientStates?.gname !== '' || patientStates?.pname !== '') {
						const patientInsuranceData = {
							patient_id: res?.data?.id,
							...(patientStates?.pname && {
								PlanName: patientStates?.pname,
							}),
							...(patientStates?.gname && {
								GroupName: patientStates?.gname,
							}),
							Type: 'P',
							Deleted: false,
						};
						const res = await postAddPatientInsuranceData(patientInsuranceData);
						setPostResInsuranceData(res);
					}
				}
			} else {
				if (patientStates?.iname !== '') {
					const updateInsData = {
						...(patientStates?.iname && {
							payer_id: patientStates?.iname,
						}),
						...(patientStates?.policy && {
							PolicyNumber: patientStates?.policy,
						}),
						GroupName: patientStates?.gname,
						PlanName: patientStates?.pname,
						Type: 'P',
						Deleted: false,
					};
					if (Object.keys(updateInsData)?.length > 2) {
						const res = await putPatientInsData1(idOfInsData, updateInsData);
						setPutResInsuranceData(res);
					}

					if (insuranceForms?.length > 0) {
						for (let i = 0; i < insuranceForms?.length; i++) {
							const item = insuranceForms[i];

							const payload = {
								...(item?.planName && { PlanName: item?.planName }),
								...(item?.groupName && { GroupName: item?.groupName }),
								...(item?.policyNo && { PolicyNumber: item?.policyNo }),
								...(item?.insuranceName && { payer_id: item?.insuranceName }),
								Type: 'P',
								Deleted: false,
								...(item?.action === 'post' && {
									patient_id: location?.state?.id,
								}),
							};

							if (item?.action === 'put') {
								// const id = insIds[i];
								const id = currentInsId;
								await putPatientInsData1(id, payload);
								getInsData();
							}
							if (item?.action === 'post') {
								if (item?.policyNo && item?.insuranceName) {
									await postAddPatientInsuranceData(payload);
								} else {
									// for showing error
									// ShowEmptySnackbar();
									// setTimeout(() => {
									// 	setOpenSnackbar(false);
									// }, 1500);
								}
							}
						}
					}
				} else {
					const updateInsDataWithoutPayer = {
						Deleted: true,
					};
					const res = await putPatientInsData1(
						idOfInsData,
						updateInsDataWithoutPayer
					);
					setPutResInsuranceData(res);
				}
			}
			let selectedFilesCount = selectedFiles?.length;
			let count = 0;
			for (const i of selectedFiles) {
				if (i) {
					if (i?.name) {
						const formData = new FormData();
						formData.append('file', i);
						formData.append(
							'filepath',
							practice_id + '/' + location?.state?.id
						);
						const savefile = await savefilepost(formData);
						const storeFileName = savefile?.data?.file_name;
						const storeFilePath = savefile?.data?.file_path;
						const AttachmentFilePost = {
							patient_id: location?.state?.id,
							AttachmentName: storeFileName,
							Path: storeFilePath,
							Type: i?.type,
						};
						const attachFile = await PostAttahcmentFile(AttachmentFilePost);
						if (attachFile) {
							count++;
						}
					}
				}
			}

			try {
				const response = await postPatNotes(notesLogBodyJson);
				if (response.status === 201) {
					console.log('Status check:', response);
				}
			} catch (error) {
				console.error('Error:', error);
			}
			if (count === selectedFilesCount) {
				handleClickSnackbar();
				setTimeout(() => {
					darkNavigate('/patient_list');
				}, 2000);
				setLoading(false);
			}
			setLoading(false);
			handleClickSnackbar();
			setTimeout(() => {
				darkNavigate('/patient_list');
			}, 2000);
		}
	};

	const generateChangeNotes = (initial, updated) => {
		const compareUpdatedValues = [];
		Object.keys(initial).forEach((key) => {
			if (key !== 'attachments') {
				const initialVal = initial[key] || 'empty';
				const updatedVal = updated[key] || 'empty';

				if (['discharge_date', 'DOB', 'Admission_date'].includes(key)) {
					const formattedInitial = formatDate(initialVal);
					const formattedUpdated = formatDate(updatedVal);
					const fieldName =
						key === 'discharge_date'
							? 'Discharge date'
							: key === 'DOB'
								? 'Date of Birth'
								: 'Admission date';
					if (formattedInitial !== formattedUpdated) {
						if (formattedUpdated === 'empty') {
							compareUpdatedValues.push({
								NotesText: `${fieldName} is updated from ${formattedInitial} to empty`,
							});
						} else {
							compareUpdatedValues.push({
								NotesText: `${fieldName} is updated from ${formattedInitial} to ${formattedUpdated}`,
							});
						}
					}
				} else if (
					[
						'Contact',
						'MRN',
						'Room_No',
						'Bed_No',
						'Zip',
						'City',
						'Address',
						'State',
						'planname',
						'groupname',
						'CareCoordinator',
						'CareCordinaterRelation',
						'ClinicalNotes',
						'policy',
						'insurancename',
						'carecordinatorContact',
					].includes(key)
				) {
					const isInitialEmpty =
						initialVal === null ||
						initialVal === undefined ||
						initialVal === '' ||
						initialVal === 'empty';
					const isUpdatedEmpty =
						updatedVal === null ||
						updatedVal === undefined ||
						updatedVal === '' ||
						updatedVal === 'empty';
					if (isInitialEmpty !== isUpdatedEmpty || initialVal !== updatedVal) {
						if (isUpdatedEmpty) {
							compareUpdatedValues.push({
								NotesText: `${key} is updated from ${initialVal || 'empty'} to empty`,
							});
						} else {
							compareUpdatedValues.push({
								NotesText: `${key} is updated from ${initialVal || 'empty'} to ${updatedVal}`,
							});
						}
					}
				} else if (initialVal !== updatedVal) {
					if (initialVal === 'empty') {
						compareUpdatedValues.push({
							NotesText: `${key} is added with value: ${updatedVal}`,
						});
					} else {
						compareUpdatedValues.push({
							NotesText: `${key} is updated from ${initialVal} to ${updatedVal}`,
						});
					}
				}
			}
		});

		const { added, deleted } = compareAttachments(
			initial.attachments || [],
			updated.attachments || []
		);

		if (added.length > 0) {
			added.forEach((file) => {
				compareUpdatedValues.push({
					NotesText: `Attachment '${file}' is added`,
				});
			});
		}

		// if (deleted.length > 0) {
		// 	deleted.forEach((file) => {
		// 		compareUpdatedValues.push({
		// 			NotesText: `Attachment '${file}' is deleted`,
		// 		});
		// 	});
		// }

		return compareUpdatedValues;
	};

	const genderMap = {
		F: 'Female',
		M: 'Male',
	};

	const stateMap = {
		AL: 'Alabama',
		AK: 'Alaska',
		AZ: 'Arizona',
		AR: 'Arkansas',
		NC: 'Alabama',
	};

	const getGender = (gender) => genderMap[gender] || gender;
	const getState = (stateAbbr) => stateMap[stateAbbr] || stateAbbr;

	const formatDate = (date) => {
		if (!date) {
			console.log('Date is empty or invalid:', date);
			return 'empty';
		}
		const parsedDate = new Date(date);
		if (isNaN(parsedDate.getTime())) {
			console.log('null value:', date);
			return 'null';
		}

		return new Date(
			parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000
		)
			.toISOString()
			.split('T')[0];
	};

	const initialValues = {
		Firstname: resPatData?.data?.Fname,
		Lastname: resPatData?.data?.Lname,
		DOB: formatDate(resPatData?.data?.DOB),
		Contact: resPatData?.data?.Contact,
		MRN: resPatData?.data?.MRN,
		Gender: getGender(resPatData?.data?.Gender),
		ClinicalNotes: resPatData?.data?.ClinicalNotes,
		Address: resPatData?.data?.Address,
		CareCoordinator: resPatData?.data?.CareCoordinator,
		carecordinatorContact: resPatData?.data?.CCContact,
		City: resPatData?.data?.City,
		State: getState(resPatData?.data?.State),
		CareCordinaterRelation: resPatData?.data?.CCRelation,
		Zip: resPatData?.data?.Zip,
		refphy: providers?.find(
			(provider) => provider?.id === resPatAdm?.data?.refphy_id
		)?.Fname
			? `${providers?.find((provider) => provider?.id === resPatAdm?.data?.refphy_id)?.Fname}, ${providers?.find((provider) => provider?.id === resPatAdm?.data?.refphy_id)?.Lname}`
			: 'empty',
		Room_No: resPatAdm?.data?.Room_No,

		provider: providers?.find(
			(provider) => provider?.id === resPatAdm?.data?.provider_id
		)?.Fname
			? `${providers?.find((provider) => provider?.id === resPatAdm?.data?.provider_id)?.Fname}, ${providers?.find((provider) => provider?.id === resPatAdm?.data?.provider_id)?.Lname}`
			: 'empty',

		location_id: locationGet?.filter((i) => {
			return i?.id == resPatAdm?.data?.location_id;
		})[0]?.Name,
		Admission_date: formatDate(resPatAdm?.data?.Admission_date),
		Bed_No: resPatAdm?.data?.Bed_No,
		discharge_date: formatDate(resPatAdm?.data?.discharge_date),

		policy: resPatInsurance?.data?.patient_insurances[0]?.PolicyNumber,
		groupname: resPatInsurance?.data?.patient_insurances[0]?.GroupName,
		planname: resPatInsurance?.data?.patient_insurances[0]?.PlanName,
		insurancename: insListName?.find(
			(insurance) =>
				insurance?.id === resPatInsurance?.data?.patient_insurances[0]?.payer_id
		)?.Name,
		attachments: initialAttachments,
	};

	const updatedValues = {
		Firstname: patientStates.fname,
		Lastname: patientStates.lname,
		DOB: formatDate(patientStates.dob),
		Gender: getGender(patientStates.gender),
		Contact: patientStates.contact,
		Address: patientStates.address,
		City: patientStates.city,
		State: getState(patientStates.state),
		Zip: patientStates.zip,
		MRN: patientStates.mrn,
		ClinicalNotes: patientStates.cnotes,
		CareCoordinator: patientStates.cc,
		carecordinatorContact: patientStates.con,
		CareCordinaterRelation: patientStates.ccr,

		refphy: providers?.find((provider) => provider?.id === patientStates.refphy)
			?.Fname
			? `${providers?.find((provider) => provider?.id === patientStates.refphy)?.Fname}, ${providers?.find((provider) => provider?.id === patientStates.refphy)?.Lname}`
			: 'empty',
		Room_No: patientStates.room,
		provider: providers?.find(
			(provider) => provider?.id === patientStates.provider
		)?.Fname
			? `${providers?.find((provider) => provider?.id === patientStates.provider)?.Fname}, ${providers?.find((provider) => provider?.id === patientStates.provider)?.Lname}`
			: 'empty',

		location_id: locationGet?.filter((i) => {
			return i?.id == patientStates.location;
		})[0]?.Name,
		Admission_date: formatDate(patientStates.adm),
		Bed_No: patientStates.bedNo,
		discharge_date: formatDate(patientStates.dischargeDate),
		policy: patientStates.policy,
		groupname: patientStates.gname,
		planname: patientStates.pname,
		insurancename: insListName?.find(
			(insurance) => insurance?.id === patientStates?.iname
		)?.Name,
		attachments:
			selectedFiles?.map((file) => file?.name || file?.AttachmentName) || [],
	};
	const comparisonofNotes = generateChangeNotes(initialValues, updatedValues);

	const notesLogBodyJson = {
		Patientid: resPatData?.data?.id,
		NoteCategory: 'patient',
		practice_id: resPatData?.data?.practice_id,
		Platform: 'web',
		Notes: comparisonofNotes,
	};
	useEffect(() => {
		getSinglePatietnDetailWithID();
		getPatAdmSingleDetailWithID();
		getLocationData();
		getInsData();
		getVisitlistWithID();
		showPayerName();
		getPatientNotesData(location?.state?.id, practice_id, '');
		// getAttachmentFileData();
		if (!dataFetched) {
			getAttachmentFileData();
		}
	}, [dataFetched]);

	// Download Image, Document File & Audio File function is here

	const handleDownload = (imageUrl, imageName, fileId) => {
		setSecondLoading(true);
		setDownloadingFileId(fileId);
		const path = imageUrl?.split('\\');
		if (path?.includes('_MxChAPI')) {
			let index = path.indexOf('_MxChAPI');
			let secondPart = path.slice(index + 1).join('\\');
			let url_ = s.baseUrl + '/' + secondPart;

			// Attempt to download the image
			fetch(url_)
				.then((response) => {
					if (!response.ok) {
						throw new Error('Network response was not ok');
					}
					return response.blob();
				})
				.then((blob) => {
					// Save the image using FileSaver.js
					saveAs(blob, imageName);
					setSecondLoading(false);
				})
				.catch((error) => {
					// Handle any errors
					console.error('Error downloading image:', error);
					// Optionally provide user feedback
					alert('Failed to download image. Please try again later.');
					setSecondLoading(false);
					setDownloadingFileId(null);
				});
		} else {
			console.error('Invalid imageUrl:', imageUrl);
			// Optionally provide user feedback
			alert('Invalid image URL. Unable to download.');
			setSecondLoading(false);
			setDownloadingFileId(null);
		}
	};

	return (
		<>
			<Grid
				container
				gap={1}
				// columnSpacing={1}

				sx={{
					// display: 'flex',
					// gap: {
					// 	xl: '10px',
					// 	lg: '10px',
					// 	md: '5px',
					// 	sm: '5px',
					// },
					// height: '82vh',
					// border: '2px solid #000',
					marginTop: '5px',
					marginBottom: '15px',
				}}
			>
				{/* Past Visits Record */}
				{/* <Grid
					item
					// xxl={2.5}
					// xl={2.5}
					// lg={2.5}
					// md={3.2}
					md={2.7}
					sm={12}
					xs={12}
					style={{
						border: '0.5px solid #DADADA',
						padding: {
							xl: '5px 5px',
							lg: '5px 5px',
							md: '5px 0px',
							sm: '5px 0px',
						},
						borderRadius: '5px',
						// height: '100%',
					}}
				>
					<Grid
						container
						sx={{
							padding: '4px 10px',
							borderBottom: '1px solid lightgray',
						}}
					>
						<Grid item xl={7} lg={7} md={7} sm={7} xs={7}>
							<Typography
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '18px',
									color: '#393939',
									marginBottom: '10px',
									// padding: '10px 0px 10px 20px',
								}}
							>
								Past Visits
							</Typography>
						</Grid>
						<Grid item xl={5} lg={5} md={5} sm={5} xs={5}>
							<Button
								variant="contained"
								component="label"
								startIcon={<AddTaskIcon sx={{ fontSize: '18px' }} />}
								size="small"
								sx={{
									background: '#2E68BA',
									whiteSpace: 'nowrap',
									color: 'white',
									fontSize: {
										xl: '10px',
										lg: '10px',
										md: '8px',
										sm: '9px',
										xs: '6px',
									},
								}}
								fullWidth
								onClick={() => {
									darkNavigate('/newCharge', {
										state: { patient_id: location?.state?.id },
									});
								}}
							>
								Add Charge
							</Button>
						</Grid>
					</Grid>

					{firstLoading ? (
						<Box
							sx={{
								width: '100%',
								textAlign: 'center',
							}}
						>
							<CircularProgress />
						</Box>
					) : (
						<>
							{patvisitlist && patvisitlist?.length > 0 ? (
								<Grid
									item
									xl={12}
									lg={12}
									md={12}
									sm={12}
									xs={12}
									sx={{
										maxHeight: '45vh',
										overflow: 'auto',
									}}
								>
									{patvisitlist?.map((item, i) => {
										return (
											<Grid
												key={i}
												sx={{
													display: 'flex',
													justifyContent: 'flex-start',
												}}
											>
												<Grid
													item
													xl={12}
													lg={12}
													md={12}
													sm={12}
													xs={12}
													sx={{
														padding: '5px',
														// margin: '5px 1px',
													}}
												>
													<Grid
														item
														xl={12}
														lg={12}
														md={12}
														sm={12}
														xs={12}
														sx={{
															border: '1px solid lightgray',
															background: '#E7F0FC',
															padding: '5px',
															borderRadius: '6px',
														}}
													>
														<Typography
															sx={{
																fontFamily: 'Poppins',
																color: 'black',
																fontWeight: '500',
																fontSize: '16px',
															}}
															onClick={() => {
																darkNavigate('/editCharge', {
																	state: {
																		// pastVisitId: pastVisitId,
																		pastVisitId: item?.id,
																		_patientId: location?.state?.id,
																	},
																});
															}}
														>
															Visit Date:{' '}
															<span
																style={{
																	fontFamily: 'Poppins',
																	cursor: 'pointer',
																	fontWeight: '700',
																	fontSize: '17px',
																	color: '#075AD7',
																}}
															>
																{dayjs(item?.VisitDate).format('YYYY-MM-DD')}
															</span>
														</Typography>
														<Typography
															sx={{
																fontFamily: 'Poppins',
																fontWeight: '500',
																fontSize: '16px',
																color: '#000000',
															}}
														>
															<span
																style={{
																	color: 'black',
																	fontWeight: '500',
																	fontSize: '15px',
																}}
															>
																Provider:
															</span>
															{item?.practicestaff?.Fname ||
															item?.practicestaff?.Lname
																? `${item?.practicestaff?.Lname || ''}${item?.practicestaff?.Fname ? ', ' + item?.practicestaff?.Fname : ''}`
																: ''}
															<br />
															<span
																style={{
																	color: 'black',
																	fontWeight: '500',
																	fontSize: '15px',
																}}
															>
																Status:
															</span>{' '}
															{item?.VisitStatus === 'A'
																? 'Approved'
																: item?.VisitStatus === 'B'
																	? 'Billed'
																	: item?.VisitStatus === 'O'
																		? 'Other'
																		: item?.VisitStatus === 'D'
																			? 'Draft'
																			: 'Other'}
														</Typography>
														<Typography
															sx={{
																fontFamily: 'Poppins',
																fontWeight: '500',
																fontSize: '16px',
																color: '#000000',
															}}
														>
															<span
																style={{
																	color: 'black',
																	fontWeight: '500',
																	fontSize: '15px',
																}}
															>
																Location:
															</span>{' '}
															{item?.location?.Name}
														</Typography>
													</Grid>
												</Grid>
											</Grid>
										);
									})}
								</Grid>
							) : (
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontWeight: '500',
										fontSize: '16px',
										color: '#000000',
										height: {
											xl: '50vh',
											lg: '50vh',
											md: '45vh',
											sm: '30vh',
											xs: '30vh',
										},
										marginBottom: { sm: '2rem', xs: '2rem' },
										display: 'flex',
										justifyContent: 'center',
									}}
								>
									No record Found
								</Typography>
							)}
						</>
					)}
				</Grid> */}
				{/* Patient Info */}
				<Grid
					item
					// xl={4}
					// lg={4}
					md={4}
					sm={12}
					xs={12}
					style={{
						// height: '100%',
						border: '0.5px solid #DADADA',
						borderRadius: '5px',
					}}
				>
					<Grid
						container
						sx={{
							padding: '5px 5px',
							background: '#0D406F',
							borderTopLeftRadius: '5px',
							borderTopRightRadius: '5px',
						}}
					>
						{/* hamza */}
						<Grid item xs={8}>
							<Typography
								sx={{
									fontSize: 18,
									fontWeight: '500',
									fontFamily: 'Poppins',
									color: 'white',
								}}
							>
								Patient Info
							</Typography>
						</Grid>
						<Grid item xs={4}>
							<Button
								variant="contained"
								component="label"
								startIcon={<InfoOutlined sx={{ fontSize: '18px' }} />}
								size="small"
								sx={{
									background: '#2E68BA',
									whiteSpace: 'nowrap',
									color: 'white',
									fontSize: {
										xl: '10px',
										lg: '10px',
										md: '8px',
										sm: '9px',
										xs: '6px',
									},
								}}
								fullWidth
								onClick={() => {
									handleOpenPastVisitInfo();
								}}
							>
								Past Visit Info
							</Button>
						</Grid>
					</Grid>
					<Grid container spacing={3} padding={'5px 5px'}>
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
							<TextField
								sx={{
									marginTop: '.5rem',
									marginBottom: '.5rem',
									'& .MuiInputLabel-asterisk': {
										color: 'red',
									},
									'& .MuiInputLabel-root': {
										zIndex: -1,
										fontSize: '12px',
										marginTop: '3px',
									},
								}}
								fullWidth
								size="small"
								value={patientStates?.fname}
								name="fname"
								autoComplete="off"
								onChange={(e) => {
									handleChangePatientStates(e);
									Yup.reach(schema, 'fname')
										.validate(e.target.value)
										.then(() => {
											setErrors((prevErrors) => ({
												...prevErrors,
												fname: '',
											}));
										})
										.catch((error) => {
											setErrors((prevErrors) => ({
												...prevErrors,
												fname: error.message,
											}));
										});
								}}
								required
								label="First Name"
								variant="outlined"
								id="outlined-basic"
							/>

							{errors.fname && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.fname}
								</div>
							)}
							{/* <Typography
												sx={{
													fontSize: '14px',
													fontWeight: '400',
													fontFamily: 'Poppins',
													color: '#000000',
													marginTop: '1rem',
													marginBottom: '-6px',
												}}
											>
												DOB
												<span
													style={{
														fontSize: '14px',
														fontWeight: '400',
														fontFamily: 'Poppins',
														color: '#ED2828',
													}}
												>
													*
												</span>
											</Typography> */}
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DemoContainer components={['DatePicker', 'DesktopDatePicker']}>
									<DemoItem>
										<DatePicker
											size="small"
											slotProps={{ textField: { size: 'small' } }}
											// disableFuture={true}
											label={
												<Box
													sx={{
														display: 'flex',
														fontSize: '12px',
														alignItems: 'center',
													}}
												>
													DOB
													{/* <Box
														component="span"
														sx={{ color: 'red', marginLeft: '2px' }}
													>
														*
													</Box> */}
												</Box>
											}
											sx={{
												// boxShadow: '1px 1px 10px #79ACF178 inset',
												width: '100%',
											}}
											value={
												patientStates?.dob == null
													? null
													: dayjs(new Date(patientStates?.dob))
											}
											name="dob"
											onChange={(e) => {
												handleDateOfBirthChange(e);
												// Yup.reach(schema, 'dob')
												// 	.validate(e)
												// 	.then(() => {
												// 		setErrors((prevErrors) => ({
												// 			...prevErrors,
												// 			dob: '',
												// 		}));
												// 	})
												// 	.catch((error) => {
												// 		setErrors((prevErrors) => ({
												// 			...prevErrors,
												// 			dob: error.message,
												// 		}));
												// 	});
											}}
										/>
									</DemoItem>
								</DemoContainer>
							</LocalizationProvider>
							{errors.dob && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.dob}
								</div>
							)}
							<TextField
								sx={{
									marginTop: '1rem',
									'& .MuiInputLabel-root': {
										fontSize: '12px',
										marginTop: '3px',
									},
								}}
								fullWidth
								size="small"
								name="contact"
								value={patientStates?.contact}
								onChange={(e) => {
									handleChangePatientStates(e);
								}}
								error={
									patientStates?.contact != null &&
									patientStates?.contact != '' &&
									!isFilled(patientStates?.contact)
								}
								helperText={
									patientStates?.contact != null &&
									patientStates?.contact != '' &&
									!isFilled(patientStates?.contact)
										? 'Please enter a valid phone number'
										: ''
								}
								InputProps={{
									endAdornment: (
										<InputAdornment position="start">
											<CallIcon sx={{ color: '#DDE6F1' }} />
										</InputAdornment>
									),
									inputComponent: MaskedInput,
									inputProps: {
										mask: [
											'(',
											/\d/,
											/\d/,
											/\d/,
											')',
											' ',
											/\d/,
											/\d/,
											/\d/,
											'-',
											/\d/,
											/\d/,
											/\d/,
											/\d/,
										],
									},
									sx: {
										borderRadius: '3px',
										height: '40px',
										'& .MuiOutlinedInput-input': {
											padding: '5px 0px 5px 6px',
										},
									},
								}}
								label="Contact#"
								variant="outlined"
								autoComplete="off"
							/>
							{/* <Typography
												sx={{
													fontSize: '14px',
													fontWeight: '400',
													fontFamily: 'Poppins',
													color: '#000000',
													marginTop: '1rem',
												}}
											>
												Contact#
											</Typography>
											<TextField
												id="outlined-required"
												sx={{ boxShadow: '1px 1px 10px #79ACF178 inset' }}
												fullWidth
												size="small"
												name="contact"
												value={patientStates?.contact}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'contact')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																contact: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																contact: error.message,
															}));
														});
												}}
											/> */}
							{errors.contact && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.contact}
								</div>
							)}
							<TextField
								sx={{
									marginTop: '1rem',
									marginBottom: '.5rem',
									'& .MuiInputLabel-root': {
										fontSize: '12px',
										marginTop: '3px',
									},
								}}
								fullWidth
								size="small"
								name="room"
								value={patientStates?.room || ''} // Default empty value for room
								onChange={(e) => {
									handleChangePatientStates(e); // Handling change for patient states
									Yup.reach(schema, 'room')
										.validate(e.target.value)
										.then(() => {
											setErrors((prevErrors) => ({
												...prevErrors,
												room: '',
											}));
										})
										.catch((error) => {
											setErrors((prevErrors) => ({
												...prevErrors,
												room: error.message,
											}));
										});
								}}
								label="Room#"
								variant="outlined"
								autoComplete="off"
							/>
							{errors.room && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.room}
								</div>
							)}
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DemoContainer components={['DatePicker', 'DesktopDatePicker']}>
									<DemoItem>
										<DesktopDatePicker
											size="small"
											slotProps={{ textField: { size: 'small' } }}
											sx={{
												width: '100%',
											}}
											label={
												<Box
													sx={{
														display: 'flex',
														fontSize: '12px',
														alignItems: 'center',
													}}
												>
													Adm Date
													{/* <Box
														component="span"
														sx={{ color: 'red', marginLeft: '2px' }}
													>
														*
													</Box> */}
												</Box>
											}
											value={
												patientStates?.adm == null
													? null
													: dayjs(new Date(patientStates?.adm))
											}
											name="adm"
											// disableFuture
											onChange={(e) => {
												handleAdmissionDateChange(e);
												// Yup.reach(schema, 'adm')
												// 	.validate(e)
												// 	.then(() => {
												// 		setErrors((prevErrors) => ({
												// 			...prevErrors,
												// 			adm: '',
												// 		}));
												// 	})
												// 	.catch((error) => {
												// 		setErrors((prevErrors) => ({
												// 			...prevErrors,
												// 			adm: error.message,
												// 		}));
												// 	});
											}}
										/>
									</DemoItem>
								</DemoContainer>
							</LocalizationProvider>
							{errors.adm && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.adm}
								</div>
							)}
							<FormControl
								fullWidth
								size="small"
								sx={{
									marginTop: '1rem',
									'& .MuiInputLabel-root': {
										fontSize: '12px',
										marginTop: '3px',
									},
								}}
							>
								<InputLabel id="demo-simple-select-label">Provider</InputLabel>
								<Select
									value={patientStates?.provider}
									name="provider"
									onChange={(e) => {
										handleChangePatientStates(e);
									}}
									MenuProps={{
										PaperProps: {
											style: {
												maxHeight: '200px',
												width: '130px',
												overflowY: 'auto',
												overflowX: 'auto',
												scrollbarWidth: 'thin',
												scrollbarColor: 'dark',
												msOverflowStyle: 'none',
												WebkitOverflowScrolling: 'touch',
											},
										},
									}}
									label="Provi"
									inputProps={{ 'aria-label': 'Without label' }}
								>
									{/* <MenuItem value={''}>None</MenuItem> */}
									{providers?.map((items, index) => {
										return (
											<MenuItem value={items?.id} key={index}>
												{items?.Lname + ',' + items?.Fname}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>

							{/* <Typography
												sx={{
													fontSize: '14px',
													fontWeight: '400',
													fontFamily: 'Poppins',
													color: '#000000',
													marginTop: '1rem',
												}}
											>
												Provider
												<span
													style={{
														fontSize: '14px',
														fontWeight: '400',
														fontFamily: 'Poppins',
														color: '#ED2828',
													}}
												>
													*
												</span>
											</Typography>
											<FormControl variant="standard" fullWidth size="small">
												<NativeSelect
													id="demo-customized-select-native"
													value={patientStates?.provider}
													name="provider"
													onChange={(e) => {
														handleChangePatientStates(e);
													}}
													input={<BootstrapInput />}
												>
													<option aria-label="None" value="" />
													{providers?.map((items, index) => {
														return (
															<option value={items?.id} key={index}>
																{items?.Fname + ',' + items?.Lname}
															</option>
														);
													})}
												</NativeSelect>
											</FormControl> */}
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
							<TextField
								sx={{
									marginTop: '.5rem',
									marginBottom: '1rem',
									'& .MuiInputLabel-asterisk': {
										color: 'red',
									},
									'& .MuiInputLabel-root': {
										zIndex: -1,
										fontSize: '12px',
										marginTop: '3px',
									},
								}}
								fullWidth
								size="small"
								name="lname"
								value={patientStates?.lname}
								onChange={(e) => {
									handleChangePatientStates(e);
									Yup.reach(schema, 'lname')
										.validate(e.target.value)
										.then(() => {
											setErrors((prevErrors) => ({
												...prevErrors,
												lname: '',
											}));
										})
										.catch((error) => {
											setErrors((prevErrors) => ({
												...prevErrors,
												lname: error?.message,
											}));
										});
								}}
								required
								label="Last Name"
								variant="outlined"
								autoComplete="off"
							/>
							{/* <Typography
												sx={{
													fontSize: '14px',
													fontWeight: '400',
													fontFamily: 'Poppins',
													color: '#000000',
													marginTop: '1rem',
												}}
											>
												Last Name
												<span
													style={{
														fontSize: '14px',
														fontWeight: '400',
														fontFamily: 'Poppins',
														color: '#ED2828',
													}}
												>
													*
												</span>
											</Typography>
											<TextField
												id="outlined-required"
												sx={{ boxShadow: '1px 1px 10px #79ACF178 inset' }}
												fullWidth
												size="small"
												name="lname"
												value={patientStates?.lname}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'lname')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																lname: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																lname: error.message,
															}));
														});
												}}
											/> */}
							{errors?.lname && (
								<div
									style={{
										color: 'red',
										fontSize: '10px',
										marginTop: '-10px',
										marginBottom: '10px',
									}}
								>
									{errors?.lname}
								</div>
							)}
							<FormControl
								fullWidth
								size="small"
								sx={{
									'& .MuiInputLabel-root': {
										fontSize: '12px',
										marginTop: '3px',
									},
								}}
							>
								<InputLabel id="demo-simple-select-label">Gender</InputLabel>
								<Select
									// labelId="demo-simple-select-label"
									// id="demo-simple-select"
									value={patientStates?.gender}
									name="gender"
									onChange={(e) => {
										handleChangePatientStates(e);
									}}
									label="Gen"
									inputProps={{ 'aria-label': 'Without label' }}
								>
									<MenuItem value="M">Male</MenuItem>
									<MenuItem value="F">Female</MenuItem>
									<MenuItem value="O">Other</MenuItem>
								</Select>
							</FormControl>

							<TextField
								sx={{
									// boxShadow: '1px 1px 10px #79ACF178 inset',
									marginTop: '1rem',
									// marginBottom: '1rem',
									'& .MuiInputLabel-root': {
										fontSize: '12px',
										marginTop: '3px',
									},
								}}
								fullWidth
								size="small"
								name="mrn"
								value={patientStates?.mrn}
								onChange={(e) => {
									handleChangePatientStates(e);
									Yup.reach(schema, 'mrn')
										.validate(e.target.value)
										.then(() => {
											setErrors((prevErrors) => ({
												...prevErrors,
												mrn: '',
											}));
										})
										.catch((error) => {
											setErrors((prevErrors) => ({
												...prevErrors,
												mrn: error.message,
											}));
										});
								}}
								label="MRN"
								variant="outlined"
								autoComplete="off"
							/>
							{errors.mrn && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.mrn}
								</div>
							)}
							<TextField
								sx={{
									marginTop: '1rem',
									marginBottom: '.5rem',
									'& .MuiInputLabel-root': {
										fontSize: '12px',
										marginTop: '3px',
									},
								}}
								fullWidth
								size="small"
								name="bedNo"
								value={patientStates?.bedNo || ''} // Default empty value for bedNo
								onChange={(e) => {
									handleChangePatientStates(e); // Handling change for patient states
									Yup.reach(schema, 'bedNo')
										.validate(e.target.value)
										.then(() => {
											setErrors((prevErrors) => ({
												...prevErrors,
												bedNo: '',
											}));
										})
										.catch((error) => {
											setErrors((prevErrors) => ({
												...prevErrors,
												bedNo: error.message,
											}));
										});
								}}
								label="Bed No"
								variant="outlined"
								autoComplete="off"
							/>
							{errors.bedNo && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.bedNo}
								</div>
							)}
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DemoContainer components={['DatePicker', 'DesktopDatePicker']}>
									<DemoItem>
										<DesktopDatePicker
											size="small"
											slotProps={{ textField: { size: 'small' } }}
											sx={{
												width: '100%',
											}}
											label={
												<Box
													sx={{
														display: 'flex',
														fontSize: '12px',
														alignItems: 'center',
													}}
												>
													Discharge Date
													{/* <Box
																		component="span"
																		sx={{ color: 'red', marginLeft: '2px' }}
																	>
																		*
																	</Box> */}
												</Box>
											}
											value={
												patientStates?.dischargeDate == null
													? null
													: dayjs(new Date(patientStates?.dischargeDate))
											}
											name="dischargeDate"
											disabled={!patientStates?.adm}
											// minDate={patientStates?.adm}
											onChange={(e) => {
												handleDischargeDateChange(e);
												// Yup.reach(schema, 'dischargeDate')
												// 	.validate(e)
												// 	.then(() => {
												// 		setErrors((prevErrors) => ({
												// 			...prevErrors,
												// 			dischargeDate: '',
												// 		}));
												// 	})
												// 	.catch((error) => {
												// 		setErrors((prevErrors) => ({
												// 			...prevErrors,
												// 			dischargeDate: error.message,
												// 		}));
												// 	});
											}}
										/>
									</DemoItem>
								</DemoContainer>
							</LocalizationProvider>
							{errors.dischargeDate && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.dischargeDate}
								</div>
							)}
							<FormControl
								fullWidth
								size="small"
								sx={{
									// boxShadow: '1px 1px 10px #79ACF178 inset',
									marginTop: '1rem',

									'& .MuiInputLabel-root': {
										fontSize: '12px',
										marginTop: '3px',
									},
								}}
							>
								<InputLabel id="demo-simple-select-label">
									Ref Phy
									{/* <span
										style={{
											fontSize: '16px',
											fontWeight: '400',
											fontFamily: 'Poppins',
											color: '#ED2828',
										}}
									>
										*
									</span> */}
								</InputLabel>
								<Select
									value={patientStates?.refphy}
									name="refphy"
									onChange={(e) => {
										handleChangePatientStates(e);
									}}
									MenuProps={{
										PaperProps: {
											style: {
												maxHeight: '200px',
												width: '130px',
												overflowY: 'auto',
												overflowX: 'auto',
												scrollbarWidth: 'thin',
												scrollbarColor: 'dark',
												msOverflowStyle: 'none',
												WebkitOverflowScrolling: 'touch',
											},
										},
									}}
									label="Ref P"
									inputProps={{ 'aria-label': 'Without label' }}
								>
									{/* <MenuItem value={''}>None</MenuItem> */}
									{providers?.map((items, index) => {
										return (
											<MenuItem value={items?.id} key={index}>
												{items?.Lname + ',' + items?.Fname}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
							{/* <Typography
												sx={{
													fontSize: '14px',
													fontWeight: '400',
													fontFamily: 'Poppins',
													color: '#000000',
													marginTop: '1rem',
												}}
											>
												Ref Phy
												<span
													style={{
														fontSize: '14px',
														fontWeight: '400',
														fontFamily: 'Poppins',
														color: '#ED2828',
													}}
												>
													*
												</span>
											</Typography>
											<FormControl variant="standard" fullWidth size="small">
												<NativeSelect
													id="demo-customized-select-native"
													value={patientStates?.refphy}
													name="refphy"
													onChange={(e) => {
														handleChangePatientStates(e);
													}}
													input={<BootstrapInput />}
												>
													<option aria-label="None" value="" />
													{providers?.map((items, index) => {
														return (
															<option value={items?.id} key={index}>
																{items?.Fname + ',' + items?.Lname}
															</option>
														);
													})}
												</NativeSelect>
											</FormControl> */}
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
							<TextField
								fullWidth
								size="small"
								name="address"
								value={patientStates?.address}
								onChange={(e) => {
									handleChangePatientStates(e);
									// Yup.reach(schema, 'address')
									// 	.validate(e.target.value)
									// 	.then(() => {
									// 		setErrors((prevErrors) => ({
									// 			...prevErrors,
									// 			address: '',
									// 		}));
									// 	})
									// 	.catch((error) => {
									// 		setErrors((prevErrors) => ({
									// 			...prevErrors,
									// 			address: error.message,
									// 		}));
									// 	});
								}}
								label="Address"
								variant="outlined"
								autoComplete="off"
								sx={{
									'& .MuiInputLabel-root': {
										zIndex: -1,
										fontSize: '12px',
										marginTop: '3px',
									},
								}}
							/>

							{/* <Typography
												sx={{
													fontSize: '14px',
													fontWeight: '400',
													fontFamily: 'Poppins',
													color: '#000000',
												}}
											>
												Address
											</Typography>
											<TextField
												id="outlined-required"
												sx={{ boxShadow: '1px 1px 10px #79ACF178 inset' }}
												fullWidth
												size="small"
												name="address"
												value={patientStates?.address}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'address')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																address: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																address: error.message,
															}));
														});
												}}
											/> */}
							{errors.address && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.address}
								</div>
							)}
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
							<FormControl
								fullWidth
								size="small"
								sx={{
									'& .MuiInputLabel-root': {
										zIndex: -1,
										fontSize: '12px',
										marginTop: '1px',
									},
								}}
							>
								<InputLabel id="demo-simple-select-label">
									Location
									{/* <span
										style={{
											fontSize: '16px',
											fontWeight: '400',
											fontFamily: 'Poppins',
											color: '#ED2828',
										}}
									>
										*
									</span> */}
								</InputLabel>
								<Select
									value={patientStates?.location}
									name="location"
									onChange={(e) => {
										handleChangePatientStates(e);
									}}
									MenuProps={{
										PaperProps: {
											style: {
												maxHeight: '200px',
												width: '130px',
												overflowY: 'auto',
												overflowX: 'auto',
												scrollbarWidth: 'thin',
												scrollbarColor: 'dark',
												msOverflowStyle: 'none',
												WebkitOverflowScrolling: 'touch',
											},
										},
									}}
									label="Locati"
									inputProps={{ 'aria-label': 'Without label' }}
								>
									{/* <MenuItem value={''}>None</MenuItem> */}
									{locationGet?.map((items, i) => {
										return (
											<MenuItem value={items?.id} key={i}>
												{items?.Name}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<Grid container spacing={2}>
								<Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
									{/* <TextField
										fullWidth
										size="small"
										name="state"
										value={patientStates?.state}
										onChange={(e) => {
											handleChangePatientStates(e);
											Yup.reach(schema, 'state')
												.validate(e.target.value)
												.then(() => {
													setErrors((prevErrors) => ({
														...prevErrors,
														state: '',
													}));
												})
												.catch((error) => {
													setErrors((prevErrors) => ({
														...prevErrors,
														state: error.message,
													}));
												});
										}}
										label="State"
										variant="outlined"
										sx={{
											'& .MuiInputLabel-root': {
												zIndex: -1,
												fontSize: '12px',
												marginTop: '3px',
											},
										}}
									/> */}
									<Autocomplete
										fullWidth
										size="small"
										name="state"
										options={states}
										getOptionLabel={(option) => option?.name || ''}
										value={
											states.find(
												(state) => state?.code === patientStates?.state
											) || null
										}
										onChange={(event, newValue) => {
											handleChangePatientStates(newValue?.code || '');
											Yup.reach(schema, 'state')
												.validate(newValue ? newValue?.code : '')
												.then(() => {
													setErrors((prevErrors) => ({
														...prevErrors,
														state: '',
													}));
												})
												.catch((error) => {
													setErrors((prevErrors) => ({
														...prevErrors,
														state: error.message,
													}));
												});
										}}
										ListboxProps={{
											style: {
												maxHeight: '160px', // Set the height here
											},
										}}
										renderInput={(params) => (
											<TextField
												{...params}
												label="State"
												variant="outlined"
												error={!!errors.state}
												helperText={errors.state}
												sx={{
													// background: '#f2f2f2',
													'& .MuiOutlinedInput-root': {
														'&.Mui-focused fieldset': {
															borderColor: '#0E6368',
														},
													},
												}}
											/>
										)}
									/>
									{errors.state && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.state}
										</div>
									)}
								</Grid>
								<Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
									<TextField
										fullWidth
										size="small"
										name="city"
										value={patientStates?.city}
										onChange={(e) => {
											handleChangePatientStates(e);
											Yup.reach(schema, 'city')
												.validate(e.target.value)
												.then(() => {
													setErrors((prevErrors) => ({
														...prevErrors,
														city: '',
													}));
												})
												.catch((error) => {
													setErrors((prevErrors) => ({
														...prevErrors,
														city: error.message,
													}));
												});
										}}
										label="City"
										variant="outlined"
										autoComplete="off"
										sx={{
											'& .MuiInputLabel-root': {
												zIndex: -1,
												fontSize: '12px',
												marginTop: '3px',
											},
										}}
									/>

									{/* <Typography
														sx={{
															fontSize: '14px',
															fontWeight: '400',
															fontFamily: 'Poppins',
															color: '#000000',
															marginTop: '.5rem',
														}}
													>
														City
													</Typography>
													<TextField
														id="outlined-required"
														sx={{
															// boxShadow: '1px 1px 10px #79ACF178 inset',
														}}
														fullWidth
														size="small"
														name="city"
														value={patientStates?.city}
														onChange={(e) => {
															handleChangePatientStates(e);
															Yup.reach(schema, 'city')
																.validate(e.target.value)
																.then(() => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		city: '',
																	}));
																})
																.catch((error) => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		city: error.message,
																	}));
																});
														}}
													/> */}
									{errors.city && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.city}
										</div>
									)}
								</Grid>
								<Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
									<TextField
										fullWidth
										size="small"
										name="zip"
										value={patientStates?.zip}
										onChange={(e) => {
											handleChangePatientStates(e);
											Yup.reach(schema, 'zip')
												.validate(e.target.value)
												.then(() => {
													setErrors((prevErrors) => ({
														...prevErrors,
														zip: '',
													}));
												})
												.catch((error) => {
													setErrors((prevErrors) => ({
														...prevErrors,
														zip: error.message,
													}));
												});
										}}
										label="Zip"
										variant="outlined"
										autoComplete="off"
										sx={{
											'& .MuiInputLabel-root': {
												zIndex: -1,
												fontSize: '12px',
												marginTop: '3px',
											},
										}}
									/>

									{/* <Typography
														sx={{
															fontSize: '14px',
															fontWeight: '400',
															fontFamily: 'Poppins',
															color: '#000000',
															marginTop: '.5rem',
														}}
													>
														Zip
													</Typography>
													<TextField
														id="outlined-required"
														sx={{
															// boxShadow: '1px 1px 10px #79ACF178 inset',
														}}
														fullWidth
														size="small"
														name="zip"
														value={patientStates?.zip}
														onChange={(e) => {
															handleChangePatientStates(e);
															Yup.reach(schema, 'zip')
																.validate(e.target.value)
																.then(() => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		zip: '',
																	}));
																})
																.catch((error) => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		zip: error.message,
																	}));
																});
														}}
													/> */}
									{errors.zip && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.zip}
										</div>
									)}
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				{/* Care Team */}
				<Grid
					item
					// xl={2.7}
					// lg={2.7}
					// md={3.6}
					md={3.8}
					sm={12}
					xs={12}
					style={{
						// height: '100%',
						border: '0.5px solid #DADADA',
						borderRadius: '5px',
					}}
				>
					<Typography
						sx={{
							fontSize: 18,
							fontWeight: '500',
							fontFamily: 'Poppins',
							padding: '5px 5px',
							color: 'white',
							background: '#0D406F',
							borderTopLeftRadius: '5px',
							borderTopRightRadius: '5px',
						}}
					>
						Care Team
					</Typography>
					<Grid container padding={'5px 5px'}>
						<TextField
							sx={{
								marginTop: '.5rem',
								'& .MuiInputLabel-root': {
									fontSize: '12px',
									marginTop: '3px',
								},
							}}
							fullWidth
							size="small"
							name="cc"
							value={patientStates?.cc}
							onChange={(e) => {
								handleChangePatientStates(e);
								Yup.reach(schema, 'cc')
									.validate(e.target.value)
									.then(() => {
										setErrors((prevErrors) => ({
											...prevErrors,
											cc: '',
										}));
									})
									.catch((error) => {
										setErrors((prevErrors) => ({
											...prevErrors,
											cc: error.message,
										}));
									});
							}}
							label="Care Coordinator"
							variant="outlined"
							autoComplete="off"
						/>
						{/* <Typography
												sx={{
													fontSize: '14px',
													fontWeight: '550',
													fontFamily: 'Poppins',
													color: '#000000',
													marginTop: '.3rem',
												}}
											>
												Care Coordinator
											</Typography>
											<TextField
												id="outlined-required"
												sx={{ boxShadow: '1px 1px 10px #79ACF178 inset' }}
												fullWidth
												size="small"
												name="cc"
												value={patientStates?.cc}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'cc')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																cc: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																cc: error.message,
															}));
														});
												}}
											/> */}
						{errors.cc && (
							<div style={{ color: 'red', fontSize: '10px' }}>{errors.cc}</div>
						)}
						<TextField
							sx={{
								// boxShadow: '1px 1px 10px #79ACF178 inset',
								marginTop: '1rem',
								'& .MuiInputLabel-root': {
									fontSize: '12px',
									marginTop: '3px',
								},
							}}
							fullWidth
							size="small"
							name="ccr"
							value={patientStates?.ccr}
							onChange={(e) => {
								handleChangePatientStates(e);
								Yup.reach(schema, 'ccr')
									.validate(e.target.value)
									.then(() => {
										setErrors((prevErrors) => ({
											...prevErrors,
											ccr: '',
										}));
									})
									.catch((error) => {
										setErrors((prevErrors) => ({
											...prevErrors,
											ccr: error.message,
										}));
									});
							}}
							label="Care Coordinator Relation"
							variant="outlined"
							autoComplete="off"
						/>
						{/* <Typography
												sx={{
													fontSize: '14px',
													fontWeight: '550',
													fontFamily: 'Poppins',
													color: '#000000',
													marginTop: '.2rem',
												}}
											>
												Care Coordinator Relation
											</Typography>
											<TextField
												id="outlined-required"
												sx={{ boxShadow: '1px 1px 10px #79ACF178 inset' }}
												fullWidth
												size="small"
												name="ccr"
												value={patientStates?.ccr}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'ccr')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																ccr: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																ccr: error.message,
															}));
														});
												}}
											/> */}
						{errors.ccr && (
							<div style={{ color: 'red', fontSize: '10px' }}>{errors.ccr}</div>
						)}
						<TextField
							sx={{
								// boxShadow: '1px 1px 10px #79ACF178 inset',
								marginTop: '.8rem',
								'& .MuiInputLabel-root': {
									fontSize: '12px',
									marginTop: '3px',
								},
							}}
							fullWidth
							size="small"
							name="con"
							value={patientStates?.con}
							onChange={(e) => {
								handleChangePatientStates(e);
								// Yup.reach(schema, 'con')
								// 	.validate(e.target.value)
								// 	.then(() => {
								// 		setErrors((prevErrors) => ({
								// 			...prevErrors,
								// 			con: '',
								// 		}));
								// 	})
								// 	.catch((error) => {
								// 		setErrors((prevErrors) => ({
								// 			...prevErrors,
								// 			con: error.message,
								// 		}));
								// 	});
							}}
							InputProps={{
								endAdornment: (
									<InputAdornment position="start">
										<CallIcon sx={{ color: '#DDE6F1' }} />
									</InputAdornment>
								),
								inputComponent: MaskedInput,
								inputProps: {
									mask: [
										'(',
										/\d/,
										/\d/,
										/\d/,
										')',
										' ',
										/\d/,
										/\d/,
										/\d/,
										'-',
										/\d/,
										/\d/,
										/\d/,
										/\d/,
									],
								},
								sx: {
									borderRadius: '3px',
									height: '40px',
									'& .MuiOutlinedInput-input': {
										padding: '5px 0px 5px 6px',
									},
								},
							}}
							error={
								patientStates?.con != '' &&
								patientStates?.con != null &&
								!isFilled(patientStates?.con)
							}
							helperText={
								patientStates?.con != '' &&
								patientStates?.con != null &&
								!isFilled(patientStates?.con)
									? 'Please enter a valid phone number'
									: ''
							}
							label="Contact#"
							variant="outlined"
							autoComplete="off"
						/>
						{/* <Typography
												sx={{
													fontSize: '14px',
													fontWeight: '550',
													fontFamily: 'Poppins',
													color: '#000000',
												}}
											>
												Contact#
											</Typography>
											<TextField
												id="outlined-required"
												sx={{ boxShadow: '1px 1px 10px #79ACF178 inset' }}
												fullWidth
												size="small"
												name="con"
												value={patientStates?.con}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'con')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																con: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																con: error.message,
															}));
														});
												}}
											/> */}
						{errors.con && (
							<div style={{ color: 'red', fontSize: '10px' }}>{errors.con}</div>
						)}
						<TextField
							sx={{
								// boxShadow: '1px 1px 10px #79ACF178 inset',
								marginTop: '.5rem',
								'& .MuiInputLabel-root': {
									fontSize: '10px',
									marginTop: '2px',
								},
							}}
							fullWidth
							size="small"
							multiline
							rows={3}
							name="cnotes"
							value={patientStates?.cnotes}
							onChange={(e) => {
								handleChangePatientStates(e);
								// Yup.reach(schema, 'cnotes')
								// 	.validate(e.target.value)
								// 	.then(() => {
								// 		setErrors((prevErrors) => ({
								// 			...prevErrors,
								// 			cnotes: '',
								// 		}));
								// 	})
								// 	.catch((error) => {
								// 		setErrors((prevErrors) => ({
								// 			...prevErrors,
								// 			cnotes: error.message,
								// 		}));
								// 	});
							}}
							label="Clinical Notes"
							variant="outlined"
							autoComplete="off"
						/>
						{/* <Typography
												sx={{
													fontSize: '14px',
													fontWeight: '400',
													fontFamily: 'Poppins',
													color: '#000000',
												}}
											>
												Clinical Notes
											</Typography>
											<TextField
												id="input-with-icon-textfield"
												sx={{ boxShadow: '1px 1px 10px #79ACF178 inset' }}
												fullWidth
												size="small"
												multiline
												rows={3}
												name="cnotes"
												value={patientStates?.cnotes}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'cnotes')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																cnotes: '', // Clear error if validation passes
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																cnotes: error.message, // Set error message if validation fails
															}));
														});
												}}
											/> */}
						{errors.cnotes && (
							<div style={{ color: 'red', fontSize: '10px' }}>
								{errors.cnotes}
							</div>
						)}{' '}
						{/* Display validation error */}
					</Grid>
					{/* <hr
						style={{
							marginTop: '10px',
							marginBottom: '10px',
							marginLeft: '-5px',
							width: '103%',
							color: '#DADADA',
						}}
					/> */}
					<Grid item xl={12} lg={12} md={12} sm={12} xs={12} align="left">
						<Grid
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
							}}
						>
							<Typography
								sx={{
									fontSize: 13,
									fontWeight: '500',
									fontFamily: 'Poppins',
									color: '#BC1111',
									padding: '10px 5px',
								}}
							>
								Attachments
							</Typography>
							<Button
								variant="contained"
								component="label"
								size="small"
								sx={{
									background: '#2E68BA',
									color: 'white',
									marginRight: '5px',
									fontSize: {
										xl: '12px',
										lg: '10px',
										md: '7px',
										sm: '12px',
										xs: '8px',
									},
								}}
							>
								<Box display={'flex'} alignItems={'center'} gap={1}>
									<AddIcon
										sx={{
											fontSize: {
												xl: '15px',
												lg: '15px',
												md: '15px',
												sm: '15px',
												xs: '14px',
											},
										}}
									/>
									Select Files
								</Box>
								<input
									type="file"
									ref={fileInputRef}
									multiple
									style={{ display: 'none' }}
									onChange={handleFileSelect}
									accept=".pdf,.doc,.docx,.xls,.xlsx, .png, .jpg,.jpeg"
								/>
							</Button>
						</Grid>
					</Grid>
					{loading ? (
						<Box
							sx={{
								marginLeft: 'auto',
								marginRight: 'auto',
								marginTop: '3rem',
							}}
						>
							<CircularProgress />
						</Box>
					) : (
						<>
							{showErr && (
								<Box sx={{ textAlign: 'center' }}>
									<Typography
										sx={{
											fontSize: '14px',
											fontWeight: '600',
											fontFamily: 'Poppins',
											color: 'white',
											backgroundColor: 'red',
											borderRadius: '8px',
											marginBottom: '-.3rem',
										}}
									>
										File is Already Exist
									</Typography>
								</Box>
							)}
							{selectedFiles?.length > 0 ? (
								<div style={{ padding: '10px' }}>
									<Box
										sx={{
											display: 'flex',
											flexDirection: 'column',
											borderRadius: '5px',

											height: {
												xl: '30vh',
												lg: '20vh',
												md: '20vh',
												sm: '15vh',
												xs: '10vh',
											},
											overflow: 'auto',
											border: '1px solid lightgray',
										}}
									>
										{selectedFiles?.map((file, index) => (
											<>
												{' '}
												<Grid container>
													<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
														<Box
															// component="li"
															key={index}
															display="flex"
															alignItems="center"
															justifyContent={'space-between'}
															sx={{
																borderRadius: '8px',
																background: '#EDFFF4',
																fontSize: '12px',
																padding: '5px',
																margin: '5px',
																border: '1px solid lightgray',
															}}
														>
															<Typography
																variant="body2"
																sx={{
																	mr: 1,
																	fontSize: {
																		xl: '15px',
																		lg: '10px',
																		md: '9px',
																		sm: '9px',
																		xs: '9px',
																	},
																}}
															>
																{file?.name || file?.AttachmentName}
															</Typography>
														</Box>
													</Grid>
													<Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
														<Box
															sx={{
																display: 'flex',
																marginTop: '.4rem',
															}}
														>
															<IconButton
																size="small"
																onClick={() => {
																	if (file?.id) {
																		deleteFileGetId(file);
																	} else {
																		handleFileRemove(file);
																	}
																}}
															>
																<CancelIcon
																	sx={{
																		fontSize: {
																			xl: '20px',
																			lg: '20px',
																			md: '18px',
																			sm: '20px',
																			xs: '20px',
																		},
																		color: 'red',
																	}}
																/>
															</IconButton>
														</Box>
													</Grid>
													<Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
														<Box
															sx={{
																display: 'flex',
																marginTop: '.8rem',
															}}
														>
															{file?.AttachmentName && (
																<Box
																	size="small"
																	sx={{
																		cursor: 'pointer',
																		// textAlign: 'center',
																	}}
																	onClick={() => {
																		handleDownload(
																			file?.Path,
																			file?.AttachmentName,
																			file?.id
																		);
																	}}
																>
																	{secondLoading &&
																	downloadingFileId === file?.id ? (
																		<Box>
																			<CircularProgress size={30} />
																		</Box>
																	) : (
																		<>
																			<DownloadIcon
																				sx={{
																					fontSize: {
																						xl: '20px',
																						lg: '20px',
																						md: '20px',
																						sm: '20px',
																						xs: '20px',
																					},
																					color: 'green',
																				}}
																			/>
																		</>
																	)}
																</Box>
															)}
														</Box>
													</Grid>
												</Grid>
											</>
										))}
									</Box>
								</div>
							) : (
								<Box
									p={0}
									m={0}
									sx={{
										display: 'flex',
										flexDirection: 'column',
										justifyContent: 'center',
										padding: ' 5px 10px',
										margin: ' 5px 10px',
										// height: '100%',
										overflow: 'auto',
										// border: '1px solid lightgray',
										textAlign: 'center',
									}}
								>
									<Typography
										sx={{
											marginTop: {
												xl: '3rem',
												lg: '3rem',
												md: '3rem',
												sm: '3rem',
												xs: '3rem',
											},
											fontFamily: 'Poppins',
											fontWeight: '500',
											fontSize: '16px',
											color: '#000000',
										}}
									>
										No Files Found
									</Typography>
								</Box>
							)}
						</>
					)}
				</Grid>
				{/* Insurance Info */}
				<Grid
					item
					// xl={2.5}
					// lg={2.5}
					md={4}
					sm={12}
					xs={12}
					style={{
						// height: '40%',
						border: '0.5px solid #DADADA',
						borderRadius: '5px',
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					<Typography
						sx={{
							fontSize: 18,
							fontWeight: '500',
							fontFamily: 'Poppins',
							color: 'white',
							padding: '5px 5px',
							background: '#0D406F',
							borderTopLeftRadius: '5px',
							borderTopRightRadius: '5px',
						}}
					>
						Insurance Info
					</Typography>
					<Grid container spacing={2} padding={'5px 5px'}>
						{/* Data Grid Details */}
						<Grid item xs={12}>
							<Box
								sx={{
									height: '30vh',
								}}
							>
								<DataGrid
									rows={allInsuranceData}
									rowHeight={35}
									columnHeaderHeight={35}
									columns={InsuranceColumn}
									rowCount={allInsuranceData?.length}
									slots={{
										noRowsOverlay: () => null,
									}}
									loading={loading}
									disableRowSelectionOnClick
									paginationModel={paginationModel}
									onPaginationModelChange={(e) => {
										setPaginationModel({
											page: e.page,
											pageSize: e.pageSize,
										});
										if (
											paginationModel.page != 0 &&
											paginationModel.pageSize === 10 &&
											paginationModel.page % 9 === 0
										) {
											setChangePage((prev) => {
												return {
													in_Page_Number: prev.in_Page_Number + 1,
													in_Rows: prev.in_Rows + 100,
												};
											});
										} else if (
											(paginationModel.page == 0 ||
												paginationModel.page !== 0) &&
											paginationModel.pageSize === 100
										) {
											setChangePage((prev) => {
												return {
													in_Page_Number: prev.in_Page_Number + 1,
													in_Rows: prev.in_Rows + 100,
												};
											});
										} else if (
											paginationModel.page != 0 &&
											paginationModel.pageSize === 25 &&
											paginationModel.page % 3 === 0
										) {
											setChangePage((prev) => {
												return {
													in_Page_Number: prev.in_Page_Number + 1,
													in_Rows: prev.in_Rows + 100,
												};
											});
										} else if (
											paginationModel.page != 0 &&
											paginationModel.pageSize === 50 &&
											paginationModel.page % 1 === 0
										) {
											setChangePage((prev) => {
												return {
													in_Page_Number: prev.in_Page_Number + 1,
													in_Rows: prev.in_Rows + 100,
												};
											});
										}
									}}
									pageSizeOptions={[5, 10, 25, 50, 100]}
									sx={{
										maxHeight: '40vh',
										'& .MuiDataGrid-columnHeader': {
											backgroundColor: '#2081B8',
											color: '#FFFFFF',
											fontFamily: 'Poppins',
											fontWeight: '300',
											fontSize: {
												xl: '15px',
												lg: '13px',
												md: '13px',
												sm: '13px',
												xs: '13px',
											},
											overflow: 'hidden',
											'.MuiSvgIcon-root': {
												color: 'white',
											},
										},
										'& .MuiDataGrid-footerContainer': {
											justifyContent: 'flex-start',
											backgroundColor: '#DCF0FF',
											height: '5px',
											fontSize: {
												xl: '15px',
												lg: '13px',
												md: '13px',
												sm: '13px',
												xs: '13px',
											},
										},

										'& .MuiInputBase-root': {
											border: '0.5px solid #383838',
											width: '60px',
											height: '30px',
											borderRadius: '10%',
											backgroundColor: 'white',
										},
										color: 'black',
										fontSize: {
											xs: '12px',
											sm: '12px',
											md: '12px',
											lg: '12px',
											xl: '14px',
										},
										'& .MuiDataGrid-virtualScroller': {
											overflowY: 'auto !important',
										},
										// '& .MuiTablePagination-displayedRows': {
										// 	display: 'none',
										// },
										'& .MuiTablePagination-selectLabel': {
											display: 'none',
										},
										// '& .MuiTablePagination-select': {
										// 	display: 'none',
										// },
										// '& .MuiTablePagination-selectIcon': {
										// 	display: 'none',
										// },
									}}
								/>{' '}
							</Box>
						</Grid>

						{/* <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
							<TextField
								sx={{
									marginTop: '.5rem',
									'& .MuiInputLabel-root': {
										zIndex: -1,
										fontSize: '12px',
										marginTop: '3px',
									},
								}}
								fullWidth
								size="small"
								name="pname"
								value={patientStates?.pname}
								onChange={(e) => {
									handleChangePatientStates(e);
									Yup.reach(schema, 'pname')
										.validate(e.target.value)
										.then(() => {
											setErrors((prevErrors) => ({
												...prevErrors,
												pname: '',
											}));
										})
										.catch((error) => {
											setErrors((prevErrors) => ({
												...prevErrors,
												pname: error.message,
											}));
										});
								}}
								label="Plan Name"
								variant="outlined"
								autoComplete="off"
							/>
							{errors.pname && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.pname}
								</div>
							)}
							<TextField
								sx={{
									marginTop: '15px',
									'& .MuiInputLabel-root': {
										zIndex: -1,
										fontSize: '12px',
										marginTop: '3px',
									},
								}}
								fullWidth
								size="small"
								name="gname"
								value={patientStates?.gname}
								onChange={(e) => {
									handleChangePatientStates(e);
									Yup.reach(schema, 'gname')
										.validate(e.target.value)
										.then(() => {
											setErrors((prevErrors) => ({
												...prevErrors,
												gname: '',
											}));
										})
										.catch((error) => {
											setErrors((prevErrors) => ({
												...prevErrors,
												gname: error.message,
											}));
										});
								}}
								label="Group Name"
								variant="outlined"
								autoComplete="off"
							/>
							{errors.gname && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.gname}
								</div>
							)}
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
							<FormControl
								fullWidth
								size="small"
								sx={{
									marginTop: '.5rem',
									'& .MuiInputLabel-root': {
										zIndex: -1,
									},
								}}
							>
								<InputLabel
									id="demo-simple-select-label"
									sx={{ fontSize: '11.5px', marginTop: '3px' }}
								>
									Insurance Name
								</InputLabel>
								<Select
									name="iname"
									value={patientStates?.iname}
									onChange={(e) => {
										handleChangePatientStates(e);
									}}
									MenuProps={{
										PaperProps: {
											style: {
												maxHeight: '200px',
												width: '130px',
												overflowY: 'auto',
												scrollbarWidth: 'thin',
												scrollbarColor: 'dark',
												msOverflowStyle: 'none',
												WebkitOverflowScrolling: 'touch',
											},
										},
									}}
									sx={{
										'& .MuiInputBase-input': {
											fontSize: '10px',
										},
										// '& .MuiSelect-label': {
										// 	fontSize: '10px',
										// },
									}}
									label="Insurance "
									inputProps={{ 'aria-label': 'Without label' }}
								>
									<MenuItem value={''}>None</MenuItem>
									{insListName?.map((items, index) => {
										return (
											<MenuItem value={items?.id} key={index}>
												{items?.Name}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
							{patientStates?.iname && (
								<>
									<TextField
										sx={{
											marginTop: '15px',
											'& .MuiInputLabel-asterisk': {
												color: 'red',
												display: 'none',
											},
											'& .MuiInputLabel-root': {
												zIndex: -1,
												fontSize: '12px',
												marginTop: '3px',
											},
										}}
										fullWidth
										size="small"
										name="policy"
										value={patientStates?.policy}
										onChange={(e) => {
											handleChangePatientStates(e);
											Yup.reach(schema, 'policy')
												.validate(e.target.value)
												.then(() => {
													setErrors((prevErrors) => ({
														...prevErrors,
														policy: '',
													}));
												})
												.catch((error) => {
													setErrors((prevErrors) => ({
														...prevErrors,
														policy: error.message,
													}));
												});
										}}
										required
										label="Policy#"
										variant="outlined"
										autoComplete="off"
									/>
								</>
							)}
							{errors.policy && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.policy}
								</div>
							)}
						</Grid> */}
					</Grid>

					{/* Add Multiple insurance section */}

					<Box display="flex" justifyContent="flex-end" p={1}>
						{/* <IconButton
							size="small"
							sx={{
								color: '#0D406F',
							}}
							onClick={() => handleAddInsuranceForm()}
						>
							<AddCircleIcon />
						</IconButton> */}
						<Button
							variant="contained"
							component="label"
							startIcon={<AddCircleIcon sx={{ fontSize: '18px' }} />}
							size="small"
							sx={{
								background: '#2E68BA',
								whiteSpace: 'nowrap',
								color: 'white',
								fontSize: {
									lg: '10px',
									md: '8px',
									sm: '9px',
									xs: '6px',
								},
							}}
							onClick={() => handleAddInsuranceForm()}
						>
							Add
						</Button>
					</Box>

					<Box
						sx={{
							maxHeight: '230px',
							overflowY: 'auto',
							overflowX: 'hidden',
							padding: '7px 0',
						}}
					>
						{insuranceForms?.map((form, index) => (
							<Badge
								badgeContent={
									<IconButton
										size="small"
										onClick={() => {
											// if (index < insIds?.length) {
											// 	SetOpenInsPopup(true); hamza
											// 	setInsPlan(form);
											// setCurrentInsId(insIds[index]);
											// } else {
											// 	handleCloseInsuranceForm(index);
											// }

											handleCloseInsuranceForm(index);
										}}
										sx={{
											color: 'red',
											p: 0,
											mt: '8px',
											mr: '2.5rem',
										}}
									>
										<DoNotDisturbOnIcon fontSize="inherit" />
									</IconButton>
								}
								key={index}
							>
								<Grid
									container
									columnSpacing={1}
									rowSpacing={1}
									sx={{ padding: '10px 5px' }}
								>
									<Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
										<TextField
											sx={{
												marginTop: '.5rem',
												'& .MuiInputLabel-root': {
													zIndex: -1,
													fontSize: '12px',
													marginTop: '3px',
												},
											}}
											fullWidth
											size="small"
											name="planName"
											value={insuranceForms[index]?.planName}
											onChange={(e) => {
												const { name, value } = e.target;

												setInsuranceForms((prevForms) => {
													const updatedForms = [...prevForms];
													updatedForms[index] = {
														...updatedForms[index],
														[name]: value,
													};
													return updatedForms;
												});

												// Yup validation
												Yup.reach(singleInsuranceSchema, name)
													.validate(value)
													.then(() => {
														setInsErrors((prevErrors) => {
															const updatedErrors = [...prevErrors];
															updatedErrors[index] = {
																...updatedErrors[index],
																[name]: '',
															};
															return updatedErrors;
														});
													})
													.catch((error) => {
														setInsErrors((prevErrors) => {
															const updatedErrors = [...prevErrors];
															updatedErrors[index] = {
																...updatedErrors[index],
																[name]: error.message,
															};
															return updatedErrors;
														});
													});
											}}
											label="Plan Name"
											variant="outlined"
											autoComplete="off"
										/>

										{insErrors[index]?.planName && (
											<>
												<Typography
													variant="caption"
													style={{
														color: 'red',
														fontSize: '10.5px',
														padding: 0,
													}}
												>
													{insErrors[index]?.planName}
												</Typography>
											</>
										)}
										<TextField
											sx={{
												marginTop: '15px',
												'& .MuiInputLabel-root': {
													zIndex: -1,
													fontSize: '12px',
													marginTop: '3px',
												},
											}}
											fullWidth
											size="small"
											name="groupName"
											value={insuranceForms[index]?.groupName || ''}
											onChange={(e) => {
												const { name, value } = e.target;

												setInsuranceForms((prevForms) => {
													const updatedForms = [...prevForms];
													updatedForms[index] = {
														...updatedForms[index],
														[name]: value,
													};
													return updatedForms;
												});

												// Yup validation
												Yup.reach(singleInsuranceSchema, name)
													.validate(value)
													.then(() => {
														setInsErrors((prevErrors) => {
															const updatedErrors = [...prevErrors];
															updatedErrors[index] = {
																...updatedErrors[index],
																[name]: '',
															};
															return updatedErrors;
														});
													})
													.catch((error) => {
														setInsErrors((prevErrors) => {
															const updatedErrors = [...prevErrors];
															updatedErrors[index] = {
																...updatedErrors[index],
																[name]: error.message,
															};
															return updatedErrors;
														});
													});
											}}
											label="Group Name"
											variant="outlined"
											autoComplete="off"
										/>
										{insErrors[index]?.groupName && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{insErrors[index]?.groupName}
											</div>
										)}
									</Grid>
									<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
										<FormControl
											fullWidth
											size="small"
											sx={{
												marginTop: '.5rem',
												'& .MuiInputLabel-root': {
													zIndex: -1,
													fontSize: '12px',
													marginTop: '3px',
												},
											}}
										>
											<InputLabel
												id="demo-simple-select-label"
												sx={{
													fontSize: {
														lg: '16px',
														md: '13px',
														sm: '16px',
														xs: '16px',
													},
												}}
											>
												Insurance Name
											</InputLabel>
											<Select
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												name="insuranceName"
												value={insuranceForms[index]?.insuranceName || ''}
												onChange={(e) => {
													const { name, value } = e.target;

													setInsuranceForms((prevForms) => {
														const updatedForms = [...prevForms];
														updatedForms[index] = {
															...updatedForms[index],
															[name]: value,
														};
														return updatedForms;
													});
												}}
												MenuProps={{
													PaperProps: {
														style: {
															maxHeight: '200px',
															width: '130px',
															overflowY: 'auto',
															scrollbarWidth: 'thin',
															scrollbarColor: 'dark',
															msOverflowStyle: 'none',
															WebkitOverflowScrolling: 'touch',
														},
													},
												}}
												label="Insurance Name"
												inputProps={{ 'aria-label': 'Without label' }}
											>
												<MenuItem value={''}>None</MenuItem>
												{insListName?.map((items, index) => {
													return (
														<MenuItem value={items?.id} key={index}>
															{items?.Name}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
										{form?.insuranceName && (
											<>
												<TextField
													sx={{
														marginTop: '15px',
														'& .MuiInputLabel-root': {
															zIndex: -1,
															fontSize: '12px',
															marginTop: '3px',
														},
														'& .MuiInputLabel-asterisk': {
															color: 'red',
														},
													}}
													fullWidth
													size="small"
													name="policyNo"
													value={insuranceForms[index]?.policyNo || ''}
													onChange={(e) => {
														const { name, value } = e.target;

														setInsuranceForms((prevForms) => {
															const updatedForms = [...prevForms];
															updatedForms[index] = {
																...updatedForms[index],
																[name]: value,
															};
															return updatedForms;
														});
														// Yup validation
														Yup.reach(singleInsuranceSchema, name)
															.validate(value)
															.then(() => {
																setInsErrors((prevErrors) => {
																	const updatedErrors = [...prevErrors];
																	updatedErrors[index] = {
																		...updatedErrors[index],
																		[name]: '',
																	};
																	return updatedErrors;
																});
															})
															.catch((error) => {
																setInsErrors((prevErrors) => {
																	const updatedErrors = [...prevErrors];
																	updatedErrors[index] = {
																		...updatedErrors[index],
																		[name]: error.message,
																	};
																	return updatedErrors;
																});
															});
													}}
													required
													label="Policy#"
													variant="outlined"
													autoComplete="off"
												/>
											</>
										)}
										{insErrors[index]?.policyNo && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{insErrors[index]?.policyNo}
											</div>
										)}
									</Grid>
								</Grid>
							</Badge>
						))}
					</Box>
				</Grid>
			</Grid>

			{/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: -4 }}>
				<Box
					sx={{
						padding: '10px',
						width: '100%',
						maxWidth: '1360px',
						xs: { maxWidth: '100%' },
						sm: { maxWidth: '90%' },
						md: { maxWidth: '80%' },
					}}
				>
					{notes?.length !== 0 && (
						<>
							<span
								style={{
									fontSize: '12px',
									fontWeight: '600',
									color: 'black',
								}}
							>
								Change History
							</span>
							<Box
								sx={{
									maxHeight: '90px',
									overflowY: 'auto',
									border: '1px solid silver',
								}}
							>
								<table style={{ width: '100%', borderCollapse: 'collapse' }}>
									<thead>
										<tr>
											<th
												style={{
													padding: '5px',
													backgroundColor: '#0D406F',
													borderBottom: '2px solid #ddd',
													textAlign: 'left',
													fontSize: '12px',
													fontWeight: '600',
													color: 'white',
													position: 'sticky',
													top: 0,
													zIndex: 1,
													borderRight: '1px solid #ddd',
													height: '10px',
												}}
											>
												Date
											</th>
											<th
												style={{
													padding: '5px',
													backgroundColor: '#0D406F',
													borderBottom: '2px solid #ddd',
													textAlign: 'left',
													fontSize: '12px',
													fontWeight: '600',
													color: 'white',
													position: 'sticky',
													top: 0,
													zIndex: 1,
													borderRight: '1px solid #ddd',
													height: '10px',
												}}
											>
												User Name
											</th>
											<th
												style={{
													padding: '5px',
													backgroundColor: '#0D406F',
													borderBottom: '2px solid #ddd',
													textAlign: 'left',
													fontSize: '12px',
													fontWeight: '600',
													color: 'white',
													position: 'sticky',
													top: 0,
													zIndex: 1,
													height: '10px',
												}}
											>
												Notes
											</th>
										</tr>
									</thead>
									<tbody>
										{notes?.map((note) => (
											<tr key={note.id}>
												<td
													style={{
														padding: '7px',
														fontSize: '13px',
														color: '#B0B0B0',
														fontStyle: 'italic',
														borderBottom: '1px solid #ddd',
														borderRight: '1px solid #ddd',
														backgroundColor: '#F9F9F9',
														height: '30px',
													}}
												>
													{dayjs(note.created_date).format('MMMM DD, YYYY')}
												</td>
												<td
													style={{
														padding: '6px',
														fontSize: '13px',
														color: '#B0B0B0',
														fontStyle: 'italic',
														borderBottom: '1px solid #ddd',
														borderRight: '1px solid #ddd',
														backgroundColor: '#F9F9F9',
														height: '25px',
													}}
												>
													{username}
												</td>
												<td
													style={{
														padding: '6px',
														fontSize: '13px',
														color: '#B0B0B0',
														fontStyle: 'italic',
														borderBottom: '1px solid #ddd',
														backgroundColor: '#F9F9F9',
														height: '25px',
													}}
												>
													<Tooltip title={note.note_text} placement="top">
														<span>{note.note_text}</span>
													</Tooltip>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</Box>
						</>
					)}
				</Box>
			</Box> */}
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
				<Box
					sx={{
						padding: '10px',
						width: '100%',
						maxWidth: '1360px',
						xs: { maxWidth: '100%' },
						sm: { maxWidth: '90%' },
						md: { maxWidth: '80%' },
					}}
				>
					{notes?.length !== 0 && (
						<>
							{/* <Box
								sx={{
									display: 'flex',
									alignItems: 'center',
									cursor: 'pointer',
								}}
								onClick={toggleNotes}
							>
								<HistoryIcon sx={{ marginRight: 1, color: '#0D406F' }} />
								<span
									style={{
										fontSize: '12px',
										fontWeight: '600',
										color: '#0D406F',
									}}
								>
									Change History
								</span>
							</Box> */}
							{notes?.length !== 0 && showNotes && (
								<Box sx={{ paddingLeft: '10px', marginTop: '-1px' }}>
									{/* <div
												onClick={toggleNotes}
												style={{
													display: 'flex',
													alignItems: 'center',
													cursor: 'pointer',
												}}
											>
												<HistoryIcon sx={{ marginRight: 1, color: '#0D406F' }} />
												<span
													style={{
														fontSize: '11px',
														fontWeight: '600',
														color: '#0D406F',
													}}
												>
													Change History
												</span>
											</div> */}
									{showNotes && (
										<Drawer
											anchor="right"
											open={showNotes}
											onClose={() => setShowNotes(false)}
											sx={{
												'& .MuiDrawer-paper': {
													width: { xs: '90%', sm: '70%', md: '50%', lg: '40%' },
													padding: 2,
												},
											}}
										>
											<Box
												sx={{
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
													mb: 2,
												}}
											>
												<Typography
													variant="h6"
													sx={{ fontWeight: 600, color: '#0D406F' }}
												>
													Notes
												</Typography>
												<IconButton onClick={() => setShowNotes(false)}>
													<CloseIcon />
												</IconButton>
											</Box>

											<Box
												sx={{
													maxHeight: 'calc(100vh - 100px)',
													overflowY: 'auto',
													border: '1px solid silver',
												}}
											>
												<table
													style={{ width: '100%', borderCollapse: 'collapse' }}
												>
													<thead>
														<tr>
															<th
																style={{
																	padding: '4px',
																	backgroundColor: '#0D406F',
																	borderBottom: '2px solid #ddd',
																	borderRight: '2px solid #ddd',
																	textAlign: 'left',
																	fontSize: '11px',
																	fontWeight: '600',
																	color: 'white',
																	position: 'sticky',
																	top: 0,
																	zIndex: 1,
																	height: '25px',
																}}
															>
																Date
															</th>
															<th
																style={{
																	padding: '4px',
																	backgroundColor: '#0D406F',
																	borderBottom: '2px solid #ddd',
																	borderRight: '2px solid #ddd',
																	textAlign: 'left',
																	fontSize: '11px',
																	fontWeight: '600',
																	color: 'white',
																	position: 'sticky',
																	top: 0,
																	zIndex: 1,
																	height: '25px',
																}}
															>
																User Name
															</th>
															<th
																style={{
																	padding: '4px',
																	backgroundColor: '#0D406F',
																	borderBottom: '2px solid #ddd',
																	textAlign: 'left',
																	fontSize: '11px',
																	fontWeight: '600',
																	color: 'white',
																	position: 'sticky',
																	top: 0,
																	zIndex: 1,
																	height: '25px',
																}}
															>
																Notes
															</th>
														</tr>
													</thead>
													<tbody>
														{notes?.map((note) => (
															<tr key={note.id}>
																<td
																	style={{
																		padding: '5px',
																		fontSize: '12px',
																		// color: '#B0B0B0',
																		fontStyle: 'italic',
																		borderBottom: '1px solid #ddd',
																		borderRight: '1px solid #ddd',
																		backgroundColor: '#F9F9F9',
																		height: '22px',
																	}}
																>
																	{dayjs(note.created_date).format(
																		'MMMM DD, YYYY'
																	)}
																</td>
																<td
																	style={{
																		padding: '5px',
																		fontSize: '12px',
																		// color: '#B0B0B0',
																		fontStyle: 'italic',
																		borderBottom: '1px solid #ddd',
																		borderRight: '1px solid #ddd',
																		backgroundColor: '#F9F9F9',
																		height: '22px',
																	}}
																>
																	{username}
																</td>
																<td
																	style={{
																		padding: '5px',
																		fontSize: '12px',
																		// color: '#B0B0B0',
																		fontStyle: 'italic',
																		borderBottom: '1px solid #ddd',
																		backgroundColor: '#F9F9F9',
																		height: '22px',
																	}}
																>
																	<Tooltip
																		title={note.note_text}
																		placement="top"
																	>
																		<span>
																			{note.note_text?.length > 150
																				? note.note_text?.slice(0, 150) + '...'
																				: note.note_text}
																		</span>
																	</Tooltip>
																</td>
															</tr>
														))}
													</tbody>
												</table>
											</Box>
										</Drawer>
									)}
								</Box>
							)}
						</>
					)}
				</Box>
			</Box>
			<Box
				item
				sx={{
					display: 'flex',
					gap: '10px',
					justifyContent: 'flex-end',
					padding: '0.5rem 1rem',
					// width: '94%',
					// position: 'fixed',
					// bottom: 10,
					marginTop: '-2px',
				}}
				style={{ position: 'absolute', bottom: '10px', right: '10px' }}
			>
				<Button
					onClick={() => toggleNotes()}
					variant="contained"
					sx={{ backgroundColor: '#2E68BA', cursor: 'pointer' }}
				>
					Notes History
				</Button>
				<Button
					onClick={() => {
						darkNavigate('/patient_list');
					}}
					style={{
						backgroundColor: '#ED2828',
						fontSize: '12px',
					}}
					variant="contained"
					size="large"
				>
					Cancel
				</Button>
				<Button
					style={{
						backgroundColor: editSave ? '#E0E0E0' : '#FD7702',
						fontSize: '12px',
					}}
					onClick={() => {
						buttonSubmit(updateData, updatePatAdmData, notesLogBodyJson);
					}}
					variant="contained"
					size="small"
					disabled={editSave ? true : false}
				>
					Save
				</Button>

				<Snackbar
					open={openSnackbar}
					onClose={handleCloseSnackbar}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
				>
					<Alert
						onClose={handleCloseSnackbar}
						severity="success"
						variant="filled"
						sx={{
							width: '100%',
							height: '3rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={() => {
										darkNavigate('/patient_list');
									}}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '16px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						Patient Successfully Updated !
					</Alert>
				</Snackbar>

				{/* Snackbar for Validation fields */}

				<Snackbar
					open={openValidateSnackbar}
					onClose={CancelEmptySnackbar}
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'center',
					}}
				>
					<Alert
						onClose={CancelEmptySnackbar}
						severity="error"
						variant="filled"
						sx={{
							width: '100%',
							height: '4rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={CancelEmptySnackbar}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '16px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						Must Validate All Fields !
					</Alert>
				</Snackbar>

				{/* Snackbar for Empty fields */}

				<Snackbar
					open={openEmptySnackbar}
					onClose={CancelEmptySnackbar}
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'center',
					}}
				>
					<Alert
						onClose={CancelEmptySnackbar}
						severity="error"
						variant="filled"
						sx={{
							width: '100%',
							height: '4rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={CancelEmptySnackbar}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '16px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						Must Fill All Fields !
					</Alert>
				</Snackbar>
			</Box>

			{/* Delete Dialogue for Attachment file */}
			<Dialog
				fullScreen={fullScreen}
				open={deletePopupOpen}
				onClose={handleClose}
				aria-labelledby="responsive-dialog-title"
				PaperProps={{
					style: { borderRadius: 8 },
				}}
			>
				<DialogTitle id="responsive-dialog-title">
					<Grid container>
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12} align="left">
							<Typography
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '32',
								}}
							>
								{' '}
								Confirmation
							</Typography>
						</Grid>
					</Grid>
					<Box
						sx={{
							textAlign: 'right',
							marginTop: '-1.7rem',
							marginRight: '-10px',
						}}
					>
						<CancelIcon
							sx={{
								fontSize: '24px',
								color: 'red',
								marginLeft: '1rem',
								cursor: 'pointer',
							}}
							onClick={deleteCancelPopup}
						/>
					</Box>
				</DialogTitle>
				<DialogContent>
					<Typography
						textAlign="center"
						sx={{
							fontFamily: 'Poppins',
							fontWeight: '500',
							fontSize: '24',
						}}
					>
						{' '}
						Do you want to delete{' '}
						<span
							style={{
								fontFamily: 'Poppins',
								fontWeight: '600',
								fontSize: '16px',
								color: '#075AD7',
							}}
						>
							{dataForDelete?.AttachmentName}
						</span>{' '}
						?
					</Typography>
					<br />
					<Grid container spacing={2} align="center">
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="right">
							<Button
								style={{ backgroundColor: '#ED2828', width: '75%' }}
								variant="contained"
								size="small"
								autoFocus
								onClick={deleteCancelPopup}
							>
								No
							</Button>
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="left">
							{/* <Button
								style={{ backgroundColor: '#FD7702', width: '75%' }}
								variant="contained"
								size="small"
								onClick={() => {
									if (dataForDelete?.id) {
										setLoading(true);
										openChooseImg1(dataForDelete?.id, deleteFile);
										handleFileRemove(dataForDelete);
									} else {
										handleFileRemove(dataForDelete);
									}
								}}
								autoFocus
							>
								Yes
							</Button> */}
							<Button
								style={{ backgroundColor: '#FD7702', width: '75%' }}
								variant="contained"
								size="small"
								onClick={async () => {
									if (dataForDelete?.id) {
										setLoading(true);
										const actionNotes = [
											{
												NotesText: `Attachment '${dataForDelete?.AttachmentName}' is deleted`,
											},
										];
										const notesLogBodyJson = {
											Patientid: resPatData?.data?.id,
											NoteCategory: 'patient',
											practice_id: resPatData?.data?.practice_id,
											Platform: 'web',
											Notes: actionNotes,
										};
										await postPatNotes(notesLogBodyJson);
										await openChooseImg1(dataForDelete?.id, deleteFile);
										handleFileRemove(dataForDelete);
										setLoading(false);
									} else {
										handleFileRemove(dataForDelete);
									}
								}}
								autoFocus
							>
								Yes
							</Button>
						</Grid>
					</Grid>
				</DialogContent>
			</Dialog>

			{/* Delete Dialogue Insurance */}
			<Dialog
				fullScreen={fullScreen}
				open={openInsPopup}
				aria-labelledby="responsive-dialog-title"
				PaperProps={{
					style: { borderRadius: 8 },
				}}
			>
				<DialogTitle id="responsive-dialog-title">
					<Grid container>
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12} align="left">
							<Typography
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '32',
								}}
							>
								{' '}
								Confirmation
							</Typography>
						</Grid>
					</Grid>
					<Box
						sx={{
							textAlign: 'right',
							marginTop: '-1.7rem',
							marginRight: '-10px',
						}}
					>
						<CancelIcon
							sx={{
								fontSize: '24px',
								color: 'red',
								marginLeft: '1rem',
								cursor: 'pointer',
							}}
							onClick={deleteInsPopup}
						/>
					</Box>
				</DialogTitle>
				<DialogContent>
					<Typography
						textAlign="center"
						sx={{
							fontFamily: 'Poppins',
							fontWeight: '500',
							fontSize: '24',
						}}
					>
						{' '}
						Do you want to delete this plan &nbsp;
						<span
							style={{
								fontFamily: 'Poppins',
								fontWeight: '600',
								fontSize: '16px',
								color: '#075AD7',
							}}
						>
							{insPlan?.planName}
						</span>{' '}
						?
					</Typography>
					<br />
					<Grid container spacing={2} align="center">
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="right">
							<Button
								style={{ backgroundColor: '#ED2828', width: '75%' }}
								variant="contained"
								size="small"
								autoFocus
								onClick={deleteInsPopup}
							>
								No
							</Button>
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="left">
							<Button
								style={{ backgroundColor: '#FD7702', width: '75%' }}
								variant="contained"
								size="small"
								onClick={async () => {
									if (location?.state?.id) {
										const res = await putPatientInsData1(currentInsId, {
											payer_id: insPlan?.insuranceName,
											patient_id: parseInt(location?.state?.id),
											Deleted: true,
										});
										if (res?.status === 200) {
											deleteInsPopup();
											getInsData();
										}
									}
								}}
								autoFocus
							>
								Yes
							</Button>
						</Grid>
					</Grid>
				</DialogContent>
			</Dialog>

			<Modal
				open={openPastVisitInfo}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						width: 400,
						bgcolor: 'background.paper',
						borderRadius: 1,
					}}
				>
					<Typography
						sx={{
							fontSize: 18,
							fontWeight: '500',
							fontFamily: 'Poppins',
							padding: '5px 5px',
							color: 'white',
							background: '#0D406F',
							borderTopLeftRadius: '5px',
							borderTopRightRadius: '5px',
						}}
					>
						Past Visit Info
					</Typography>
					{/* Past Visits Record */}
					<Grid
						container
						style={{
							border: '0.5px solid #DADADA',
							padding: {
								xl: '5px 5px',
								lg: '5px 5px',
								md: '5px 0px',
								sm: '5px 0px',
							},
							borderRadius: '5px',
							// height: '100%',
						}}
					>
						<Grid
							container
							sx={{
								padding: '4px 10px',
								borderBottom: '1px solid lightgray',
							}}
						>
							<Grid item xl={7} lg={7} md={7} sm={7} xs={7}>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontWeight: '600',
										fontSize: '18px',
										color: '#393939',
										marginBottom: '10px',
										// padding: '10px 0px 10px 20px',
									}}
								>
									Past Visits
								</Typography>
							</Grid>
							<Grid item xl={5} lg={5} md={5} sm={5} xs={5}>
								<Button
									variant="contained"
									component="label"
									startIcon={<AddTaskIcon sx={{ fontSize: '18px' }} />}
									size="small"
									sx={{
										background: '#2E68BA',
										whiteSpace: 'nowrap',
										color: 'white',
										fontSize: {
											xl: '10px',
											lg: '10px',
											md: '8px',
											sm: '9px',
											xs: '6px',
										},
									}}
									fullWidth
									onClick={() => {
										darkNavigate('/newCharge', {
											state: { patient_id: location?.state?.id },
										});
									}}
								>
									Add Charge
								</Button>
							</Grid>
						</Grid>

						{firstLoading ? (
							<Box
								sx={{
									width: '100%',
									textAlign: 'center',
								}}
							>
								<CircularProgress />
							</Box>
						) : (
							<>
								{patvisitlist && patvisitlist?.length > 0 ? (
									<Grid
										item
										xl={12}
										lg={12}
										md={12}
										sm={12}
										xs={12}
										sx={{
											maxHeight: '45vh',
											overflow: 'auto',
										}}
									>
										{patvisitlist?.map((item, i) => {
											return (
												<Grid
													key={i}
													sx={{
														display: 'flex',
														justifyContent: 'flex-start',
													}}
												>
													<Grid
														item
														xl={12}
														lg={12}
														md={12}
														sm={12}
														xs={12}
														sx={{
															padding: '5px',
															// margin: '5px 1px',
														}}
													>
														<Grid
															item
															xl={12}
															lg={12}
															md={12}
															sm={12}
															xs={12}
															sx={{
																border: '1px solid lightgray',
																background: '#E7F0FC',
																padding: '5px',
																borderRadius: '6px',
															}}
														>
															<Typography
																sx={{
																	fontFamily: 'Poppins',
																	color: 'black',
																	fontWeight: '500',
																	fontSize: '16px',
																}}
																onClick={() => {
																	darkNavigate('/editCharge', {
																		state: {
																			// pastVisitId: pastVisitId,
																			pastVisitId: item?.id,
																			_patientId: location?.state?.id,
																		},
																	});
																}}
															>
																Visit Date:{' '}
																<span
																	style={{
																		fontFamily: 'Poppins',
																		cursor: 'pointer',
																		fontWeight: '700',
																		fontSize: '17px',
																		color: '#075AD7',
																	}}
																>
																	{dayjs(item?.VisitDate).format('YYYY-MM-DD')}
																</span>
															</Typography>
															<Typography
																sx={{
																	fontFamily: 'Poppins',
																	fontWeight: '500',
																	fontSize: '16px',
																	color: '#000000',
																}}
															>
																<span
																	style={{
																		color: 'black',
																		fontWeight: '500',
																		fontSize: '15px',
																	}}
																>
																	Provider:
																</span>
																{item?.practicestaff?.Fname ||
																item?.practicestaff?.Lname
																	? `${item?.practicestaff?.Lname || ''}${item?.practicestaff?.Fname ? ', ' + item?.practicestaff?.Fname : ''}`
																	: ''}
																<br />
																<span
																	style={{
																		color: 'black',
																		fontWeight: '500',
																		fontSize: '15px',
																	}}
																>
																	Status:
																</span>{' '}
																{item?.VisitStatus === 'A'
																	? 'Approved'
																	: item?.VisitStatus === 'B'
																		? 'Billed'
																		: item?.VisitStatus === 'O'
																			? 'Other'
																			: item?.VisitStatus === 'D'
																				? 'Draft'
																				: 'Other'}
															</Typography>
															<Typography
																sx={{
																	fontFamily: 'Poppins',
																	fontWeight: '500',
																	fontSize: '16px',
																	color: '#000000',
																}}
															>
																<span
																	style={{
																		color: 'black',
																		fontWeight: '500',
																		fontSize: '15px',
																	}}
																>
																	Location:
																</span>{' '}
																{item?.location?.Name}
															</Typography>
														</Grid>
													</Grid>
												</Grid>
											);
										})}
									</Grid>
								) : (
									<Typography
										sx={{
											fontFamily: 'Poppins',
											fontWeight: '500',
											fontSize: '16px',
											color: '#000000',
											height: {
												xl: '50vh',
												lg: '50vh',
												md: '45vh',
												sm: '30vh',
												xs: '30vh',
											},
											marginBottom: { sm: '2rem', xs: '2rem' },
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											width: '100%',
										}}
									>
										No record Found
									</Typography>
								)}
							</>
						)}
					</Grid>
					<Box textAlign={'center'} p={1}>
						<Button
							variant="contained"
							component="label"
							size="small"
							sx={{
								background: '#ED2828',
								whiteSpace: 'nowrap',
								color: 'white',
								fontSize: '10px',
							}}
							onClick={() => {
								handleClosePastVisitInfo();
							}}
						>
							Close
						</Button>
					</Box>
				</Box>
			</Modal>
		</>
	);
}

export default EditPatient;
